import styled from '@emotion/styled';
import React, { createContext, useContext, useRef, useState, useEffect, useCallback, useReducer } from 'react';
import { keyframes } from '@emotion/core';
import { Player } from '@kaizenplatform/kaizen-video-player';
import 'construct-style-sheets-polyfill';
import * as History from 'history';
import dayjs from 'dayjs';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var unitlessKeys$1 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var _default$1 = unitlessKeys$1;

var unitless_cjs_prod = /*#__PURE__*/Object.defineProperty({
	default: _default$1
}, '__esModule', {value: true});

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var _default = unitlessKeys;

var unitless_cjs_dev = /*#__PURE__*/Object.defineProperty({
	default: _default
}, '__esModule', {value: true});

var unitless_cjs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === "production") {
  module.exports = unitless_cjs_prod;
} else {
  module.exports = unitless_cjs_dev;
}
});

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_cjs[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var YOKONAGAS = ["16:9", "6:5"];
var TATENAGAS = ["4:5", "3:4", "2:3", "9:16"];
var BREAKPOINT = {
  sp: 768 - 1,
  tab: 1080 - 1
};
var ZERO = 0;
var ONE = 1;
var DEFAULT_OFFSET = 0;
var DEFAULT_LIMIT = undefined;
var SELECT_KOUKAIZIREI_KEY = "ORG/KOKAI";
var defaultSelected = {
  placement: "ALL",
  duration: "ALL",
  aspectRatio: "ALL",
  industry: "ALL"
};

var initialState$3 = {
  isWrapped: false,
  modalContensType: null,
  selectedCard: null,
  checkedCards: [],
  initialLoaded: false,
  tagInput: "",
  query: "",
  selectedPlacement: undefined,
  selectedDuration: undefined,
  selectedAspect: undefined,
  selectedIndustry: undefined,
  selectedOrganizations: [],
  isSelectedAll: false,
  selectedOrganizationTags: [],
  cursor: ZERO,
  isFavFilter: false,
  includeOtherOrganizations: ONE,
  isOpenSearchMobileModal: false,
  isOpenSpCardMobileModal: false,
  isPlayAllVideos: false,
  selectdContentTypes: [],
  businessRegion: [],
  scope: [],
  service: [],
  offset: undefined,
  limit: DEFAULT_LIMIT,
  isMobile: false,
  isOriginal: undefined,
  currentOrganizationId: undefined,
  isPublishedAtSales: [],
  targetStreamingUrl: "originalHlsUrl",
  loadingImageSrc: undefined
};
var AdSearchPageStateContext = /*#__PURE__*/createContext(__assign({}, initialState$3));
var AdSearchPageDispatchContext = /*#__PURE__*/createContext({
  dispatch: function dispatch() {
    return null;
  }
});
var useAdSearchPageStateContext = function useAdSearchPageStateContext() {
  return useContext(AdSearchPageStateContext);
};
var useAdSearchPageDispatchContext = function useAdSearchPageDispatchContext() {
  return useContext(AdSearchPageDispatchContext);
};

var initialState$2 = {
  adSearch: {
    isLoading: false,
    isLoaded: false,
    data: undefined,
    error: null,
    selectedVideos: [],
    queryCache: {
      query: undefined,
      duration: undefined,
      aspectRatio: undefined,
      industry: undefined,
      placement: undefined,
      offset: DEFAULT_OFFSET,
      limit: DEFAULT_LIMIT,
      selectedOrganizations: [],
      organizationTag: [],
      includeOtherOrganizations: ONE,
      isFavFilter: false,
      contentTypes: [],
      businessRegion: [],
      scope: [],
      service: [],
      isPublishedAtSales: [],
      isCreatedAtSales: 0
    }
  },
  fetchCreativeListState: {
    error: undefined
  },
  fetchSelectedCreativesState: {
    error: undefined
  },
  postOrganizationTagState: {
    error: undefined
  },
  deleteOrganizationTagState: {
    error: undefined
  },
  postFavoriteState: {
    error: undefined
  },
  deleteFavoriteState: {
    error: undefined
  }
};
var AdSearchStateContext = /*#__PURE__*/createContext(__assign({}, initialState$2));
var AdSearchDispatchContext = /*#__PURE__*/createContext({
  dispatch: function dispatch() {
    return null;
  }
});
var useAdSearchStateContext = function useAdSearchStateContext() {
  return useContext(AdSearchStateContext);
};
var useAdSearchDispatchContext = function useAdSearchDispatchContext() {
  return useContext(AdSearchDispatchContext);
};

/**
 * __Container__
 * - creative-search-ui が提供するUIコンポーネントのためのレイアウトを提供します
 * - component `Container` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります
 * @param {IContainerProps} props
 * @param {ReactNode} props.children
 * @param {JSX.Element} [props.loadingSpinner] - ローディング時に表示するスピナーを指定する場合に指定
 * @param {IContainerStyledProps["overrideCss"]} [props.overrideCss] - デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @example
 * import { Container, IContainerProps } from 'creative-search-ui'
 *
 * const YourComponent = () => {
 *   return <Container loadingSpinner={<YourSpinner />} overrideCss={yourOverrideCss} />
 * }
 */

var Container = function Container(_a) {
  var children = _a.children,
      loadingSpinner = _a.loadingSpinner,
      overrideCss = _a.overrideCss;
  var adSearchPageState = useAdSearchPageStateContext();
  var adSearchState = useAdSearchStateContext();
  if (!adSearchPageState.isWrapped) throw new Error("Provider is missing. Please wrap with CreativeSearchProvider");
  var isLoadingVideos = !adSearchState.adSearch.isLoading && adSearchState.adSearch.isLoaded && adSearchState.adSearch.data && !adSearchState.adSearch.error || adSearchState.adSearch.data && adSearchPageState.initialLoaded;
  if (!isLoadingVideos) return loadingSpinner || null;
  return /*#__PURE__*/React.createElement(Wrapper$9, {
    className: "csui-container-wrapper",
    isOpenSearchMobileModal: adSearchPageState.isOpenSearchMobileModal,
    overrideCss: overrideCss
  }, children);
};
var Wrapper$9 = styled("div")(function (_a) {
  var isOpenSearchMobileModal = _a.isOpenSearchMobileModal,
      overrideCss = _a.overrideCss;
  var baseCss = {
    "&.csui-container-wrapper": {
      position: isOpenSearchMobileModal ? "fixed" : "relative",
      padding: "8px",
      scrollBehavior: "smooth",
      maxWidth: "1080px",
      margin: "auto"
    }
  };
  var additionalCss = overrideCss && overrideCss({
    isOpenSearchMobileModal: isOpenSearchMobileModal
  });
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

/**
 * @file adSearchPage の UI に関する reducer
 */
var ACTION_TYPE$1 = {
  // 検索フォームの入力アクション
  SELECT_PLACEMENT_ACTION: "SELECT_PLACEMENT_ACTION",
  SELECT_DURATION: "SELECT_DURATION",
  SELECT_ASPECT: "SELECT_ASPECT",
  SELECT_INDUSTRY: "SELECT_INDUSTRY",
  SELECT_ORGANIZATIONS: "SELECT_ORGANIZATIONS",
  SELECT_ORGANIZATION_TAGS: "SELECT_ORGANIZATION_TAGS",
  SELECT_ALL_ORGANIZATIONS: "SELECT_ALL_ORGANIZATIONS",
  INPUT_QUERY: "INPUT_QUERY",
  SET_INCLUDE_OTHER_ORGANIZATIONS: "SET_INCLUDE_OTHER_ORGANIZATIONS",
  ON_INCLIDE_OTHER_ORGANIZATIONS: "ON_INCLIDE_OTHER_ORGANIZATIONS",
  OFF_INCLIDE_OTHER_ORGANIZATIONS: "OFF_INCLIDE_OTHER_ORGANIZATIONS",
  // カーソルのセット
  SET_CURSOR: "SET_CURSOR",
  SET_IS_FAV_FILTER: "SET_IS_FAV_FILTER",
  TOGGLE_FAV_FILTER: "TOGGLE_FAV_FILTER",
  SELECT_CARD: "SELECT_CARD",
  SELECT_CARDS: "SELECT_CARDS",
  INPUT_TAG: "INPUT_TAG",
  SET_INITIAL_LOAD: "SET_INITIAL_LOAD",
  SET_MODAL_TYPE: "SET_MODAL_TYPE",
  SET_SP_SEARCH_MODAL: "SET_SP_SEARCH_MODAL",
  SET_SP_CARD_MODAL: "SET_SP_CARD_MODAL",
  REHYDRATE: "REHYDRATE",
  SET_PLAY_ALL_VIDEOS: "SET_PLAY_ALL_VIDEOS",
  SELECT_CONTENT_TYPE: "SELECT_CONTENT_TYPE",
  SET_SEARCH_CONDITIONS: "SET_SEARCH_CONDITIONS",
  SET_OFFSET: "SET_OFFSET",
  SET_LIMIT: "SET_LIMIT",
  SET_IS_MOBILE: "SET_IS_MOBILE",
  SET_COMPOUND_QUERY: "SET_COMPOUND_QUERY",
  SET_IS_ORIGINAL: "SET_IS_ORIGINAL",
  SET_CURRENT_ORGANIZATION_ID: "SET_CURRENT_ORGANIZATION_ID",
  SET_TARGET_STREAMING_URL: "SET_TARGET_STREAMING_URL",
  SET_LOADING_IMAGE_SRC: "SET_LOADING_IMAGE_SRC"
};

var setPlayAllVideos = function setPlayAllVideos(data) {
  return {
    type: ACTION_TYPE$1.SET_PLAY_ALL_VIDEOS,
    payload: data
  };
};

var setModalTypeAction = function setModalTypeAction(data) {
  return {
    type: ACTION_TYPE$1.SET_MODAL_TYPE,
    payload: data
  };
};

var selectPlacementAction = function selectPlacementAction(data) {
  return {
    type: ACTION_TYPE$1.SELECT_PLACEMENT_ACTION,
    payload: data
  };
};

var selectDurationAction = function selectDurationAction(data) {
  return {
    type: ACTION_TYPE$1.SELECT_DURATION,
    payload: data
  };
};

var selectAspectAction = function selectAspectAction(data) {
  return {
    type: ACTION_TYPE$1.SELECT_ASPECT,
    payload: data
  };
};

var selectIndustryAction = function selectIndustryAction(data) {
  return {
    type: ACTION_TYPE$1.SELECT_INDUSTRY,
    payload: data
  };
};

var selectContentType = function selectContentType(data) {
  return {
    type: ACTION_TYPE$1.SELECT_CONTENT_TYPE,
    payload: data
  };
};

var selectOrganizationsAction = function selectOrganizationsAction(data) {
  return {
    type: ACTION_TYPE$1.SELECT_ORGANIZATIONS,
    payload: data
  };
};

var selectOrganizationTagsAction = function selectOrganizationTagsAction(data) {
  return {
    type: ACTION_TYPE$1.SELECT_ORGANIZATION_TAGS,
    payload: data
  };
};

var selectAllOrganizationsAction = function selectAllOrganizationsAction(data) {
  return {
    type: ACTION_TYPE$1.SELECT_ALL_ORGANIZATIONS,
    payload: data
  };
};

var inputQueryAction = function inputQueryAction(data) {
  return {
    type: ACTION_TYPE$1.INPUT_QUERY,
    payload: data
  };
};

var selectCardAction = function selectCardAction(data) {
  return {
    type: ACTION_TYPE$1.SELECT_CARD,
    payload: data
  };
};

var setCursorAction = function setCursorAction(data) {
  return {
    type: ACTION_TYPE$1.SET_CURSOR,
    payload: data
  };
};

var setIsFavFilter = function setIsFavFilter(data) {
  return {
    type: ACTION_TYPE$1.SET_IS_FAV_FILTER,
    payload: data
  };
};

var toggleFavFilterAction = function toggleFavFilterAction() {
  return {
    type: ACTION_TYPE$1.TOGGLE_FAV_FILTER
  };
};

var setInialLoadFlgAction = function setInialLoadFlgAction() {
  return {
    type: ACTION_TYPE$1.SET_INITIAL_LOAD
  };
};

var inputNewTagAction = function inputNewTagAction(data) {
  return {
    type: ACTION_TYPE$1.INPUT_TAG,
    payload: data
  };
};

var selectCardsAction = function selectCardsAction(data) {
  return {
    type: ACTION_TYPE$1.SELECT_CARDS,
    payload: data
  };
};

var setIncludeOtherOrganizations = function setIncludeOtherOrganizations(data) {
  return {
    type: ACTION_TYPE$1.SET_INCLUDE_OTHER_ORGANIZATIONS,
    payload: data
  };
};

var onIncludeOtherOrganizations = function onIncludeOtherOrganizations() {
  return {
    type: ACTION_TYPE$1.ON_INCLIDE_OTHER_ORGANIZATIONS
  };
};

var offIncludeOtherOrganizations = function offIncludeOtherOrganizations() {
  return {
    type: ACTION_TYPE$1.OFF_INCLIDE_OTHER_ORGANIZATIONS
  };
};

var setSpSearchModal = function setSpSearchModal(isOpen) {
  return {
    type: ACTION_TYPE$1.SET_SP_SEARCH_MODAL,
    payload: isOpen
  };
};

var setSpCardModal = function setSpCardModal(isOpen) {
  return {
    type: ACTION_TYPE$1.SET_SP_CARD_MODAL,
    payload: isOpen
  };
};

var rehydrate = function rehydrate(request) {
  return {
    type: ACTION_TYPE$1.REHYDRATE,
    payload: request
  };
};

var setAdditionalCondition = function setAdditionalCondition(request) {
  return {
    type: ACTION_TYPE$1.SET_SEARCH_CONDITIONS,
    payload: request
  };
};

var setOffset = function setOffset(offset) {
  return {
    type: ACTION_TYPE$1.SET_OFFSET,
    payload: offset
  };
};

var setLimit = function setLimit(limit) {
  return {
    type: ACTION_TYPE$1.SET_LIMIT,
    payload: limit
  };
};

var setIsMobile = function setIsMobile(isMobile) {
  return {
    type: ACTION_TYPE$1.SET_IS_MOBILE,
    payload: isMobile
  };
};

var setIsOriginal = function setIsOriginal(isOriginal) {
  return {
    type: ACTION_TYPE$1.SET_IS_ORIGINAL,
    payload: isOriginal
  };
};

var setCurrentOrganizationId = function setCurrentOrganizationId(currrntOrganizationId) {
  return {
    type: ACTION_TYPE$1.SET_CURRENT_ORGANIZATION_ID,
    payload: currrntOrganizationId
  };
};

var setTargetStreamingUrlAction = function setTargetStreamingUrlAction(targetStreamingUrl) {
  return {
    type: ACTION_TYPE$1.SET_TARGET_STREAMING_URL,
    payload: targetStreamingUrl
  };
};

var setLoadingImageSrcAction = function setLoadingImageSrcAction(loadingImageSrc) {
  return {
    type: ACTION_TYPE$1.SET_LOADING_IMAGE_SRC,
    payload: loadingImageSrc
  };
};

var adSearchPageActions = {
  selectPlacementAction: selectPlacementAction,
  selectDurationAction: selectDurationAction,
  selectAspectAction: selectAspectAction,
  selectIndustryAction: selectIndustryAction,
  selectOrganizationsAction: selectOrganizationsAction,
  selectOrganizationTagsAction: selectOrganizationTagsAction,
  selectAllOrganizationsAction: selectAllOrganizationsAction,
  inputQueryAction: inputQueryAction,
  selectCardAction: selectCardAction,
  setModalTypeAction: setModalTypeAction,
  setCursorAction: setCursorAction,
  setIsFavFilter: setIsFavFilter,
  toggleFavFilterAction: toggleFavFilterAction,
  setInialLoadFlgAction: setInialLoadFlgAction,
  inputNewTagAction: inputNewTagAction,
  selectCardsAction: selectCardsAction,
  setIncludeOtherOrganizations: setIncludeOtherOrganizations,
  onIncludeOtherOrganizations: onIncludeOtherOrganizations,
  offIncludeOtherOrganizations: offIncludeOtherOrganizations,
  setSpSearchModal: setSpSearchModal,
  rehydrate: rehydrate,
  setSpCardModal: setSpCardModal,
  setPlayAllVideos: setPlayAllVideos,
  selectContentType: selectContentType,
  setAdditionalCondition: setAdditionalCondition,
  setOffset: setOffset,
  setLimit: setLimit,
  setIsMobile: setIsMobile,
  setIsOriginal: setIsOriginal,
  setCurrentOrganizationId: setCurrentOrganizationId,
  setTargetStreamingUrlAction: setTargetStreamingUrlAction,
  setLoadingImageSrcAction: setLoadingImageSrcAction
};
function reducer$2(state, action) {
  switch (action.type) {
    case "SELECT_CONTENT_TYPE":
      return __assign(__assign({}, state), {
        selectdContentTypes: action.payload
      });

    case "SELECT_PLACEMENT_ACTION":
      return __assign(__assign({}, state), {
        selectedPlacement: action.payload
      });

    case "SELECT_DURATION":
      return __assign(__assign({}, state), {
        selectedDuration: action.payload
      });

    case "SELECT_ASPECT":
      return __assign(__assign({}, state), {
        selectedAspect: action.payload
      });

    case "SELECT_INDUSTRY":
      return __assign(__assign({}, state), {
        selectedIndustry: action.payload
      });

    case "SELECT_ORGANIZATIONS":
      return __assign(__assign({}, state), {
        selectedOrganizations: action.payload
      });

    case "SET_INCLUDE_OTHER_ORGANIZATIONS":
      return __assign(__assign({}, state), {
        includeOtherOrganizations: action.payload
      });

    case "ON_INCLIDE_OTHER_ORGANIZATIONS":
      return __assign(__assign({}, state), {
        includeOtherOrganizations: 1
      });

    case "OFF_INCLIDE_OTHER_ORGANIZATIONS":
      return __assign(__assign({}, state), {
        includeOtherOrganizations: 0
      });

    case "SELECT_ORGANIZATION_TAGS":
      return __assign(__assign({}, state), {
        selectedOrganizationTags: action.payload
      });

    case "SELECT_ALL_ORGANIZATIONS":
      return __assign(__assign({}, state), {
        isSelectedAll: action.payload
      });

    case "INPUT_QUERY":
      return __assign(__assign({}, state), {
        query: action.payload
      });

    case "SET_MODAL_TYPE":
      return __assign(__assign({}, state), {
        modalContensType: action.payload
      });

    case "SET_CURSOR":
      return __assign(__assign({}, state), {
        cursor: action.payload
      });

    case "SET_IS_FAV_FILTER":
      return __assign(__assign({}, state), {
        isFavFilter: action.payload
      });

    case "TOGGLE_FAV_FILTER":
      return __assign(__assign({}, state), {
        isFavFilter: !state.isFavFilter
      });

    case "SET_INITIAL_LOAD":
      return __assign(__assign({}, state), {
        initialLoaded: true
      });

    case "INPUT_TAG":
      return __assign(__assign({}, state), {
        tagInput: action.payload
      });

    case "SELECT_CARD":
      return __assign(__assign({}, state), {
        selectedCard: action.payload
      });

    case "SELECT_CARDS":
      return __assign(__assign({}, state), {
        checkedCards: action.payload
      });

    case "SET_SP_SEARCH_MODAL":
      return __assign(__assign({}, state), {
        isOpenSearchMobileModal: action.payload
      });

    case "SET_SP_CARD_MODAL":
      return __assign(__assign({}, state), {
        isOpenSpCardMobileModal: action.payload
      });

    case "SET_PLAY_ALL_VIDEOS":
      return __assign(__assign({}, state), {
        isPlayAllVideos: action.payload
      });

    case "REHYDRATE":
      return __assign(__assign({}, state), {
        query: action.payload.query,
        selectedIndustry: action.payload.industry,
        selectedDuration: action.payload.duration,
        selectedAspect: action.payload.aspectRatio,
        selectedPlacement: action.payload.placement,
        isFavFilter: action.payload.isFavFilter,
        selectedOrganizationTags: action.payload.organizationTag,
        selectdContentTypes: action.payload.contentTypes,
        businessRegion: action.payload.businessRegion,
        scope: action.payload.scope,
        service: action.payload.service,
        isPublishedAtSales: action.payload.isPublishedAtSales,
        limit: action.payload.limit
      });

    case "SET_SEARCH_CONDITIONS":
      return __assign(__assign({}, state), {
        query: "query" in action.payload ? action.payload.query : state.query,
        selectedIndustry: "industry" in action.payload ? action.payload.industry : state.selectedIndustry,
        selectedDuration: "duration" in action.payload ? action.payload.duration : state.selectedDuration,
        selectedAspect: "aspectRatio" in action.payload ? action.payload.aspectRatio : state.selectedAspect,
        selectedPlacement: "placement" in action.payload ? action.payload.placement : state.selectedPlacement,
        includeOtherOrganizations: "includeOtherOrganizations" in action.payload ? action.payload.includeOtherOrganizations === 0 ? 0 : 1 : state.includeOtherOrganizations,
        selectedOrganizations: "selectedOrganizations" in action.payload ? action.payload.selectedOrganizations || [] : state.selectedOrganizations,
        selectedOrganizationTags: "organizationTag" in action.payload ? action.payload.organizationTag || [] : state.selectedOrganizationTags,
        isFavFilter: "isFavFilter" in action.payload ? action.payload.isFavFilter || false : state.isFavFilter,
        selectdContentTypes: "contentTypes" in action.payload ? action.payload.contentTypes || [] : state.selectdContentTypes,
        businessRegion: action.payload ? action.payload.businessRegion || [] : state.businessRegion
      });

    case "SET_OFFSET":
      return __assign(__assign({}, state), {
        offset: action.payload
      });

    case "SET_LIMIT":
      return __assign(__assign({}, state), {
        limit: action.payload
      });

    case "SET_IS_MOBILE":
      return __assign(__assign({}, state), {
        isMobile: action.payload
      });

    case "SET_IS_ORIGINAL":
      return __assign(__assign({}, state), {
        isOriginal: action.payload
      });

    case "SET_CURRENT_ORGANIZATION_ID":
      return __assign(__assign({}, state), {
        currentOrganizationId: action.payload
      });

    case "SET_TARGET_STREAMING_URL":
      return __assign(__assign({}, state), {
        targetStreamingUrl: action.payload
      });

    case "SET_LOADING_IMAGE_SRC":
      return __assign(__assign({}, state), {
        loadingImageSrc: action.payload
      });

    default:
      throw new Error();
  }
}

var Spinner = function Spinner() {
  return /*#__PURE__*/React.createElement(Root$b, null);
};
var Root$b = styled("div")(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  border-radius: 50%;\n  color: #ffffff;\n  font-size: 11px;\n  text-indent: -99999em;\n  margin: 55px auto;\n  position: relative;\n  width: 10em;\n  height: 10em;\n  box-shadow: inset 0 0 0 1em;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n  &:before {\n    border-radius: 50%;\n    position: absolute;\n    content: \"\";\n    width: 5.2em;\n    height: 10.2em;\n    background: #0dc5c1;\n    border-radius: 10.2em 0 0 10.2em;\n    top: -0.1em;\n    left: -0.1em;\n    -webkit-transform-origin: 5.1em 5.1em;\n    transform-origin: 5.1em 5.1em;\n    -webkit-animation: load2 2s infinite ease 1.5s;\n    animation: load2 2s infinite ease 1.5s;\n  }\n  &:after {\n    border-radius: 50%;\n    position: absolute;\n    content: \"\";\n    width: 5.2em;\n    height: 10.2em;\n    background: #0dc5c1;\n    border-radius: 0 10.2em 10.2em 0;\n    top: -0.1em;\n    left: 4.9em;\n    -webkit-transform-origin: 0.1em 5.1em;\n    transform-origin: 0.1em 5.1em;\n    -webkit-animation: load2 2s infinite ease;\n    animation: load2 2s infinite ease;\n  }\n  @-webkit-keyframes & {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes & {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n"], ["\n  border-radius: 50%;\n  color: #ffffff;\n  font-size: 11px;\n  text-indent: -99999em;\n  margin: 55px auto;\n  position: relative;\n  width: 10em;\n  height: 10em;\n  box-shadow: inset 0 0 0 1em;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n  &:before {\n    border-radius: 50%;\n    position: absolute;\n    content: \"\";\n    width: 5.2em;\n    height: 10.2em;\n    background: #0dc5c1;\n    border-radius: 10.2em 0 0 10.2em;\n    top: -0.1em;\n    left: -0.1em;\n    -webkit-transform-origin: 5.1em 5.1em;\n    transform-origin: 5.1em 5.1em;\n    -webkit-animation: load2 2s infinite ease 1.5s;\n    animation: load2 2s infinite ease 1.5s;\n  }\n  &:after {\n    border-radius: 50%;\n    position: absolute;\n    content: \"\";\n    width: 5.2em;\n    height: 10.2em;\n    background: #0dc5c1;\n    border-radius: 0 10.2em 10.2em 0;\n    top: -0.1em;\n    left: 4.9em;\n    -webkit-transform-origin: 0.1em 5.1em;\n    transform-origin: 0.1em 5.1em;\n    -webkit-animation: load2 2s infinite ease;\n    animation: load2 2s infinite ease;\n  }\n  @-webkit-keyframes & {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes & {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n"])));
var templateObject_1$b;

var CreativeListCardMobile = function CreativeListCardMobile(props) {
  var _a;

  var creative = props.creative,
      onClickCard = props.onClickCard;
  var dispatchSearchPageCtx = useAdSearchPageDispatchContext().dispatch;
  var state = useAdSearchPageStateContext();
  var currentOrganizationId = state.currentOrganizationId;

  var handleClickCard = function handleClickCard() {
    dispatchSearchPageCtx(adSearchPageActions.selectCardAction(creative)); // ここでセットされた creative を MobileModal コンポーネントが拾う

    dispatchSearchPageCtx(adSearchPageActions.setSpCardModal(true)); // MobileModal を開く

    if (currentOrganizationId) {
      window.history.pushState("", "", "?org=" + currentOrganizationId + "&ids=" + creative.id);
    } else {
      window.history.pushState("", "", "?ids=" + creative.id);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-mobile-wrapper",
    onClick: function onClick() {
      return !onClickCard && handleClickCard();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-mobile-img-wrapper"
  }, creative.thumbnailUrl ? /*#__PURE__*/React.createElement("img", {
    className: "csui-cl-card-mobile-img",
    src: (_a = creative.thumbnailUrl) !== null && _a !== void 0 ? _a : ""
  }) : /*#__PURE__*/React.createElement(Spinner, null)));
};
var creativeListCardMobileCss = function creativeListCardMobileCss(previewHeight) {
  return {
    ".csui-cl-card-mobile-wrapper": {
      width: "100%"
    },
    ".csui-cl-card-mobile-img-wrapper": {
      height: previewHeight,
      textAlign: "center",
      backgroundColor: "black",
      position: "relative",
      width: "100%"
    },
    ".csui-cl-card-mobile-img": {
      objectFit: "contain",
      width: "100%",
      height: "100%",
      padding: "0"
    }
  };
};

var DummyAvatarIcon = function DummyAvatarIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root$a, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    className: className,
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
};
var Root$a = styled("svg")();

var MoreIcon = function MoreIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root$9, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    className: className,
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
  }));
};
var Root$9 = styled("svg")(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  height: 100%;\n  vertical-align: middle;\n  margin-left: 10px;\n  margin: auto 0;\n"], ["\n  height: 100%;\n  vertical-align: middle;\n  margin-left: 10px;\n  margin: auto 0;\n"])));
var templateObject_1$a;

var TagIcon = function TagIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root$8, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    className: className,
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
  }));
};
var Root$8 = styled("svg")(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  vertical-align: middle;\n  transform: rotate(-45deg);\n  cursor: pointer;\n  cursor: hand;\n"], ["\n  vertical-align: middle;\n  transform: rotate(-45deg);\n  cursor: pointer;\n  cursor: hand;\n"])));
var templateObject_1$9;

var initialState$1 = {
  locale: "ja"
};
var LocaleStateContext = /*#__PURE__*/createContext(__assign({}, initialState$1));
var LocaleDispatchContext = /*#__PURE__*/createContext({
  dispatch: function dispatch() {
    return null;
  }
});
var useLocaleStateContext = function useLocaleStateContext() {
  return useContext(LocaleStateContext);
};
var useLocaleDispatchContext = function useLocaleDispatchContext() {
  return useContext(LocaleDispatchContext);
};

var objectToString = function objectToString(value) {
  return Object.prototype.toString.call(value);
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any


var isObject = function isObject(value) {
  if (objectToString(value) !== "[object Object]") {
    return false;
  }

  return true;
};
var isStrArray = function isStrArray(v) {
  return Array.isArray(v) && !v.some(function (i) {
    return typeof i !== "string";
  });
};
var getMediaquery = function getMediaquery(key) {
  if (key === void 0) {
    key = "sp";
  }

  return "@media (max-width: " + BREAKPOINT[key] + "px)";
};
var sortFunc = function sortFunc(a, b) {
  var aText = a.value.toString().toLowerCase();
  var bText = b.value.toString().toLowerCase();

  if (aText === bText) {
    return 0;
  }

  if (aText === "other") {
    return 1;
  }

  if (bText === "other") {
    return -1;
  }

  if (aText === "owned_media") {
    return 1;
  }

  if (bText === "owned_media") {
    return -1;
  }

  if (bText < aText) return 1;else if (bText > aText) return -1;
  return 0;
};
var getAccessingDevice = function getAccessingDevice() {
  if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android|Mobile)/i)) {
    return "sp";
  } else {
    return "pc";
  }
};
var getContentTypeString = function getContentTypeString(contentType) {
  if (contentType.includes("video")) {
    return "creativeSearchList.contentType.video";
  } else if (contentType.includes("image")) {
    return "creativeSearchList.contentType.image";
  } else if (contentType.includes("pdf")) {
    return "creativeSearchList.contentType.pdf";
  } else {
    return "creativeSearchList.contentType.others";
  }
};
var getHHMMSStime = function getHHMMSStime(sec) {
  var hours = Math.floor(sec / 3600);
  var minutes = Math.floor((sec - hours * 3600) / 60);
  var seconds = Math.floor(sec - hours * 3600 - minutes * 60);
  ("00" + hours).slice(-2);
  ("00" + minutes).slice(-2);
  ("00" + seconds).slice(-2);

  if (hours > 0) {
    return hours + ":" + ("00" + minutes).slice(-2) + ":" + ("00" + seconds).slice(-2);
  } else {
    return minutes + ":" + ("00" + seconds).slice(-2);
  }
};

var resources = {
  en: {
    keywordForm: {
      buttonText: "Search",
      placeholder: "keyword",
      cancel: "cancel"
    },
    searchFilter: {
      filter: "filter",
      filterCategory: {
        industry: "industry",
        aspectRatio: "aspectRatio",
        placement: "placement"
      }
    },
    selectController: {
      uncheck: "uncheck videos"
    },
    tag: {
      add: "add tag",
      edit: "edit tag",
      modalTitle: "Edit Tag"
    },
    playModal: {
      playAll: "play all videos",
      close: "close"
    },
    creativeSearchList: {
      contentType: {
        video: "video",
        image: "image",
        pdf: "PDF",
        others: "others"
      }
    }
  },
  ja: {
    keywordForm: {
      buttonText: "検索",
      placeholder: "キーワード",
      cancel: "キャンセル"
    },
    searchFilter: {
      filter: "フィルター",
      filterCategory: {
        industry: "業種",
        aspectRatio: "縦横比",
        placement: "プレイスメント"
      }
    },
    selectController: {
      uncheck: "チェック解除"
    },
    tag: {
      add: "タグを追加する",
      edit: "タグを編集する",
      modalTitle: "タグの追加・編集"
    },
    playModal: {
      playAll: "全て再生",
      close: "閉じる"
    },
    creativeSearchList: {
      contentType: {
        video: "動画",
        image: "画像",
        pdf: "PDF",
        others: "その他"
      }
    }
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getNested = function getNested(obj, args) {
  return args.reduce(function (obj, level) {
    return obj && obj[level];
  }, obj);
};

var useTranslation = function useTranslation() {
  var locale = useLocaleStateContext().locale;
  var resource;

  switch (locale) {
    case "en":
      resource = resources.en;
      break;

    case "ja":
      resource = resources.ja;
      break;

    default:
      resource = resources.ja;
      break;
  } // TODO: performance


  var translate = function translate(key) {
    var found = getNested(resource, key.split("."));

    if (typeof found !== "string") {
      // NOTE: ここは無くても良いかも
      if (isObject(found)) {
        return "key: '" + key + " (" + locale + ")' returned an object instead of string.";
      }

      return key;
    }

    return found;
  };

  return {
    t: translate
  };
};

var IMAGE_CONTENT_TYPE_WHITE_LIST = ["image/bmp", "image/gif", "image/jp2", "image/jpeg", "image/png", "image/tiff"];
var MOVIE_CONTENT_TYPE_WHITE_LIST = ["video/mp4", "video/quicktime"];
var PDF_CONTENT_TYPE_WHITE_LIST = ["application/pdf"];
__spreadArray(__spreadArray(__spreadArray([], IMAGE_CONTENT_TYPE_WHITE_LIST), MOVIE_CONTENT_TYPE_WHITE_LIST), PDF_CONTENT_TYPE_WHITE_LIST);
/**
 * ファイルの拡張子を処理するUtility Class
 */

var ExtensionDeterminator =
/** @class */
function () {
  function ExtensionDeterminator() {}
  /**
   * 与えられたpathが画像か動画を識別する関数
   * @param path urlなど
   */


  ExtensionDeterminator.whichImageOrMovie = function (path) {
    var match = path.match(/\.(jpg|png|jpeg|mp4|mov|gif|MOV|bmp|jp2|tiff|quicktime|MP4)$/);

    if (!match) {
      // FIXME: このブロックへ処理が進んだ時にSentryにログを投げたい
      console.error("path:", path);
      return null; // 本番アプリケーションを止めないために握りつぶす
      // throw new Error('there is no file extension in the path.');
    }

    switch (match[1]) {
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
      case "bmp":
      case "jp2":
      case "tiff":
        return "image";

      case "mp4":
      case "MP4":
      case "mov":
      case "MOV":
      case "quicktime":
        return "movie";

      default:
        // FIXME: このブロックへ処理が進んだ時にSentryにログを投げたい
        // 画像or動画以外のものを渡されると例外を投げる
        console.error("extention:", match[1]);
        return null;
      // 本番アプリケーションを止めないために握りつぶす
      // throw new Error('there is no CreativeType extension.');
    }
  };
  /**
   * 与えられたpathが画像か動画を識別する関数
   * @param path urlなど
   */


  ExtensionDeterminator.whichImageOrMovieFromContentType = function (contentType) {
    if (IMAGE_CONTENT_TYPE_WHITE_LIST.includes(contentType)) {
      return "image";
    }

    if (MOVIE_CONTENT_TYPE_WHITE_LIST.includes(contentType)) {
      return "movie";
    }

    if (PDF_CONTENT_TYPE_WHITE_LIST.includes(contentType)) {
      return "pdf";
    }

    console.error("contentType:", contentType);
    return null; // 本番アプリケーションを止めないために握りつぶす
    // throw new Error('there is no CreativeType extension.');
  };

  return ExtensionDeterminator;
}();

var CheckIcon = function CheckIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root$7, {
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M5 13l4 4L19 7"
  }));
};
var Root$7 = styled("svg")(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  color: gray;\n  cursor: pointer;\n  cursor: hand;\n"], ["\n  color: gray;\n  cursor: pointer;\n  cursor: hand;\n"])));
var templateObject_1$8;

var CreativeListCardPcCheckBox = function CreativeListCardPcCheckBox(props) {
  var taggleChecked = function taggleChecked(e) {
    props.handleClickCheckBox(e, props.data);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, props.checked && /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-checked-box",
    onClick: taggleChecked
  }, /*#__PURE__*/React.createElement(CheckIcon, {
    className: "w-6 h-6",
    size: 18
  })), !props.checked && /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-unchecked-box",
    onClick: taggleChecked
  }, /*#__PURE__*/React.createElement("div", null)));
};
var creativeListCardPcCheckBoxCss = {
  ".csui-cl-card-pc-checked-box": {
    display: "flex",
    backgroundColor: "#00a46e",
    color: "white",
    width: "18px",
    height: "18px"
  },
  ".csui-cl-card-pc-unchecked-box": {
    border: "1px solid gray",
    display: "flex",
    backgroundColor: "white",
    width: "18px",
    height: "18px"
  }
};

var CreativeListCardPcImageScreen = function CreativeListCardPcImageScreen(_a) {
  var src = _a.src,
      clickable = _a.clickable,
      scalable = _a.scalable;
  if (clickable) return /*#__PURE__*/React.createElement("a", {
    className: "csui-cl-card-pc-img-screen-anchor-link"
  }, /*#__PURE__*/React.createElement("img", {
    className: "csui-cl-card-pc-img-screen-img",
    src: src
  }));
  return /*#__PURE__*/React.createElement("img", {
    className: scalable ? "csui-cl-card-pc-img-screen-scalable-img" : "csui-cl-card-pc-img-screen-img",
    src: src
  });
};
var createCreativeListCardPcImageScreenCss = function createCreativeListCardPcImageScreenCss(isContentTypeMixed) {
  return {
    ".csui-cl-card-pc-img-screen-anchor-link": {
      display: "flex",
      alignItems: "center"
    },
    ".csui-cl-card-pc-img-screen-img": {
      background: "#000",
      width: "100%",
      height: "100%",
      objectFit: isContentTypeMixed ? "contain" : undefined,
      borderRadius: "5px 5px 0 0"
    },
    ".csui-cl-card-pc-img-screen-scalable-img": {
      background: "#000",
      width: "100%",
      height: "100%",
      cursor: "pointer",
      transition: "transform 0.2s ease-out",
      "&:hover": {
        transform: "scale(1.5)"
      }
    }
  };
};

var VideoPlayer = function VideoPlayer(props) {
  var ref = useRef(null);

  var _a = useState(undefined),
      width = _a[0],
      setWidth = _a[1];

  var _b = useState(undefined),
      height = _b[0],
      setHeight = _b[1];

  var _c = useState(null),
      player = _c[0],
      setPlayer = _c[1];

  useEffect(function () {
    if (!ref.current) return;
    var host = ref.current;
    if (!host || !host.shadowRoot) return;
    var sheet = new CSSStyleSheet();
    host.shadowRoot.adoptedStyleSheets = [sheet];

    if (props.isPlay) {
      sheet.replaceSync(".plyr__controls { display: flex }");
    } else {
      sheet.replaceSync(".plyr__controls { display: none }");
    }
  }, [props.isPlay]);
  useEffect(function () {
    if (!player && ref.current) {
      var cssString_1 = "";

      if (props.kaizenPlayerCss) {
        Object.keys(props.kaizenPlayerCss).map(function (key) {
          var value = props.kaizenPlayerCss[key];
          var kebabcaseKey = key.split(/(?=[A-Z])/).join("-").toLowerCase();
          cssString_1 += kebabcaseKey + ":" + value + ";";
        });
      }

      var container = ref.current;
      var aspectCss = props.aspectRatioIsFixed ? "16/9" : "";
      var plyrCss = cssString_1 ? cssString_1 : "height:100%;width:100%;min-width:unset;";
      var p_1 = new Player(container, Object.assign({
        videoType: "shaka",
        plyrCss: ".plyr{" + plyrCss + "} .plyr__video-wrapper--fixed-ratio{" + aspectCss + "}"
      }, props));
      setPlayer(p_1);

      p_1.videoTag.onloadeddata = function () {
        if (p_1 && p_1.videoTag) {
          setWidth(p_1 === null || p_1 === void 0 ? void 0 : p_1.videoTag.videoWidth);
          setHeight(p_1 === null || p_1 === void 0 ? void 0 : p_1.videoTag.videoHeight);

          if (props.onReady) {
            props.onReady();
          }
        }
      };

      p_1.start();
    }
  }, []);
  useEffect(function () {
    if (player && props.isPlay && !player.playing) {
      player.resume();
    }

    if (player && !props.isPlay && player.playing) {
      player.pause();
    }
  }, [props.isPlay]);
  return /*#__PURE__*/React.createElement(Root$6, {
    ref: ref,
    className: "kaizen-video-player",
    width: width,
    height: height,
    isFullWidth: props.isFullWidth,
    isDisplayFlex: props.isDisplayFlex
  });
};
var Root$6 = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  margin: 0 auto;\n  aspect-ratio: auto ", ";\n  height: 100%;\n  max-width: 100%;\n  width: ", ";\n  display: ", ";\n"], ["\n  margin: 0 auto;\n  aspect-ratio: auto ", ";\n  height: 100%;\n  max-width: 100%;\n  width: ", ";\n  display: ", ";\n"])), function (props) {
  return props.width + " / " + props.height;
}, function (props) {
  return "" + (props.isFullWidth ? "100%" : "");
}, function (props) {
  return "" + (props.isDisplayFlex ? "flex" : "");
});
var templateObject_1$7;

var CreativeListCardPcVideoScreen = function CreativeListCardPcVideoScreen(_a) {
  var _b, _c, _d;

  var _e = _a.muted,
      muted = _e === void 0 ? true : _e;
      _a.autoPlay;
      var controls = _a.controls,
      creative = _a.creative,
      kaizenPlayerCss = _a.kaizenPlayerCss,
      isPlay = _a.isPlay;
  var state = useAdSearchPageStateContext();
  var targetStreamingUrl = state.targetStreamingUrl;
  var playerOptions = controls ? {
    controls: ["play", "progress", "current-time"]
  } : {
    controls: []
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-video-screen"
  }, /*#__PURE__*/React.createElement(VideoPlayer, {
    key: (_b = creative === null || creative === void 0 ? void 0 : creative.id) !== null && _b !== void 0 ? _b : -1,
    videoId: (_c = creative === null || creative === void 0 ? void 0 : creative.kaizenFilesId) !== null && _c !== void 0 ? _c : "",
    manifestUrl: (_d = creative[targetStreamingUrl]) !== null && _d !== void 0 ? _d : "",
    scriptKey: "",
    onReady: function onReady() {},
    aspectRatio: "16:9",
    muted: muted,
    plyrOptions: playerOptions,
    kaizenPlayerCss: kaizenPlayerCss,
    // poster={creative.thumbnailUrl ?? ""}
    autoplay: true,
    isPlay: isPlay,
    isFullWidth: true,
    isDisplayFlex: false,
    aspectRatioIsFixed: true
  }));
};
var createCreativeListCardPcVideoScreenCss = function createCreativeListCardPcVideoScreenCss(aspectRatio, previewHeight) {
  return {
    ".csui-cl-card-pc-video-screen": {
      position: "relative",
      backgroundColor: "#000",
      borderRadius: "5px 5px 0 0",
      objectFit: "contain",
      height: previewHeight,
      width: "100%",
      maxHeight: TATENAGAS.includes(aspectRatio) || YOKONAGAS.includes(aspectRatio) ? "180px" : undefined
    }
  };
};

var VISIBLE_TAG_NUM_THRESHOLD = 2;
var CreativeListCardPc = function CreativeListCardPc(_a) {
  var _b, _c, _d, _e;

  var data = _a.data,
      config = _a.config,
      _f = _a.isSelectable,
      isSelectable = _f === void 0 ? true : _f,
      _g = _a.displayProperties,
      displayProperties = _g === void 0 ? ["title", "createdDate", "ghInfo", "tag", "cardFooter"] : _g,
      _h = _a.needOpenPreviewModal,
      needOpenPreviewModal = _h === void 0 ? true : _h,
      _j = _a.needOpenTagEditModal,
      needOpenTagEditModal = _j === void 0 ? true : _j,
      _k = _a.needVideoDuration,
      needVideoDuration = _k === void 0 ? true : _k,
      cardFooterElement = _a.cardFooterElement,
      needVideoControl = _a.needVideoControl,
      kaizenPlayerCss = _a.kaizenPlayerCss,
      isFirstRender = _a.isFirstRender,
      setIsFirstRender = _a.setIsFirstRender,
      onClickCard = _a.onClickCard,
      thumbnailHoverMinimumMillisecond = _a.thumbnailHoverMinimumMillisecond;
  var t = useTranslation().t;
  var fileType = ExtensionDeterminator.whichImageOrMovieFromContentType(data.contentType);
  var state = useAdSearchPageStateContext();
  var dispatch = useAdSearchPageDispatchContext().dispatch;
  var checkedCards = state.checkedCards,
      currentOrganizationId = state.currentOrganizationId;
  var isSelected = checkedCards.map(function (card) {
    return card.id;
  }).includes(data.id);

  var _l = useState(false),
      isHover = _l[0],
      setIsHover = _l[1];

  var _m = useState(false),
      isFadingOut = _m[0],
      setIsFadingOut = _m[1];

  var targetStreamingUrl = state.targetStreamingUrl;
  /**
   * cardが選択された時の処理. 選択済みリストに追加・削除を行う
   * @param selectedCard 選択されたcard
   */

  var handleClickCheckBox = function handleClickCheckBox(e, selectedCard) {
    e.stopPropagation();

    if (checkedCards === null) {
      dispatch(adSearchPageActions.selectCardsAction([selectedCard]));
      return;
    }

    if (checkedCards.map(function (card) {
      return card.id;
    }).includes(selectedCard.id)) {
      // すでに選択済みのものが選択されると削除
      var filteredCards = checkedCards.filter(function (card) {
        return card.id !== selectedCard.id;
      });
      dispatch(adSearchPageActions.selectCardsAction(filteredCards));
    } else {
      // まだ選択していない場合ものが選択されると追加
      dispatch(adSearchPageActions.selectCardsAction(__spreadArray(__spreadArray([], checkedCards), [selectedCard])));
    }
  };

  var handleClickCard = function handleClickCard() {
    if (!needOpenPreviewModal) return;
    dispatch(adSearchPageActions.selectCardAction(data)); // ここでセットされた creative を Modal コンポーネントが拾う

    dispatch(adSearchPageActions.setModalTypeAction("preview")); // Modal コンポーネントを開く

    if (currentOrganizationId) {
      window.history.pushState("", "", "?org=" + currentOrganizationId + "&ids=" + data.id);
    } else {
      window.history.pushState("", "", "?ids=" + data.id);
    }
  };

  var openTagEditModal = function openTagEditModal(selectedCard) {
    if (!needOpenTagEditModal) return;
    dispatch(adSearchPageActions.selectCardAction(selectedCard));
    dispatch(adSearchPageActions.setModalTypeAction("tagEdit"));
  };

  var _o = useState(),
      delayHandler = _o[0],
      setDelayHandler = _o[1];

  var handleMouseEnter = function handleMouseEnter() {
    setDelayHandler(setTimeout(function () {
      setIsHover(true);
      setIsFirstRender(false);
    }, thumbnailHoverMinimumMillisecond));
  };

  var handleMouseLeave = function handleMouseLeave() {
    delayHandler && clearTimeout(delayHandler);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-creative-wrapper",
    onMouseEnter: function onMouseEnter() {
      setIsFadingOut(true);
      handleMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      handleMouseLeave();
      setIsHover(false);
      setIsFadingOut(false);
    }
  }, isSelectable ? /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-view"
  }, /*#__PURE__*/React.createElement("label", {
    className: "csui-cl-card-pc-icon-wrapper"
  }, /*#__PURE__*/React.createElement(CreativeListCardPcCheckBox, {
    checked: isSelected,
    handleClickCheckBox: handleClickCheckBox,
    data: data
  }))) : null, fileType === "movie" && /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-video-screen-wrapper",
    onClick: function onClick() {
      return !onClickCard && handleClickCard();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: (!isFirstRender || isFadingOut) && data[targetStreamingUrl] ? "csui-cl-card-pc-video-thumbnail-wrapper hide" : "csui-cl-card-pc-video-thumbnail-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    className: "csui-cl-card-pc-video-thumbnail",
    src: (_b = data.thumbnailUrl) !== null && _b !== void 0 ? _b : ""
  }), needVideoDuration && /*#__PURE__*/React.createElement("span", {
    className: "csui-cl-card-pc-video-duration"
  }, getHHMMSStime((_c = data.duration) !== null && _c !== void 0 ? _c : 0))), !isFirstRender && data[targetStreamingUrl] && /*#__PURE__*/React.createElement(CreativeListCardPcVideoScreen, {
    controls: needVideoControl,
    creative: data,
    kaizenPlayerCss: kaizenPlayerCss,
    isPlay: isHover
  })), fileType === "image" && /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-img-screen-wrapper",
    onClick: function onClick() {
      return !onClickCard && handleClickCard();
    }
  }, /*#__PURE__*/React.createElement(CreativeListCardPcImageScreen, {
    src: data.fileUrl,
    scalable: false,
    clickable: false
  })), fileType === "pdf" && data.thumbnailUrl && /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-img-screen-wrapper",
    onClick: function onClick() {
      return !onClickCard && handleClickCard();
    }
  }, /*#__PURE__*/React.createElement(CreativeListCardPcImageScreen, {
    src: (_d = data.thumbnailUrl) !== null && _d !== void 0 ? _d : "",
    scalable: false,
    clickable: false
  }))), /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-view",
    onClick: function onClick() {
      onClickCard && onClickCard(data);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-info-wrapper"
  }, displayProperties.includes("contentTypeTag") && data.contentType && /*#__PURE__*/React.createElement("span", {
    className: "csui-cl-card-pc-content-type"
  }, t(getContentTypeString(data.contentType))), displayProperties.includes("title") && data.title && /*#__PURE__*/React.createElement("span", {
    className: "csui-cl-card-pc-video-title"
  }, data.title), displayProperties.includes("createdDate") && data.createdDate && /*#__PURE__*/React.createElement("p", {
    className: "csui-cl-card-pc-video-time"
  }, data.createdDate), displayProperties.includes("tag") && /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-tag-wrapper"
  }, /*#__PURE__*/React.createElement("div", null, (_e = data.organizationTag) === null || _e === void 0 ? void 0 : _e.slice(0, VISIBLE_TAG_NUM_THRESHOLD).map(function (tag) {
    return /*#__PURE__*/React.createElement("span", {
      className: "csui-cl-card-pc-tag-span",
      key: tag
    }, tag);
  }), data.organizationTag.length > 2 && /*#__PURE__*/React.createElement(MoreIcon, {
    className: "w-6 h-6",
    size: 20
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      openTagEditModal(data);
      dispatch(adSearchPageActions.selectCardAction(data));
    },
    className: "csui-cl-card-pc-tag-icon-wrapper"
  }, /*#__PURE__*/React.createElement(TagIcon, {
    className: "w-6 h-6",
    size: 24
  }), /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-tag-tool-tip-description"
  }, /*#__PURE__*/React.createElement("span", null, t("tag.edit")))))), /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-footer-wrapper"
  }, displayProperties.includes("ghInfo") && config && /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-hacker-info-wrapper"
  }, data.optimizerProfileImageUrl ? /*#__PURE__*/React.createElement("a", {
    className: "csui-cl-card-pc-avatar-link",
    href: config.PROFILE_WEB_URL + "/users/" + data.optimizerId,
    target: "_blank",
    rel: "noreferrer",
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: data.optimizerProfileImageUrl,
    className: "csui-cl-card-pc-avatar-img"
  })) : /*#__PURE__*/React.createElement(DummyAvatarIcon, {
    className: "w-6 h-6",
    size: 30
  })), displayProperties.includes("cardFooter") && !!cardFooterElement && /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-card-pc-footer-content"
  }, cardFooterElement(data))))));
};
var creativeListCardPcCss = function creativeListCardPcCss(previewHeight) {
  var _a;

  return {
    ".csui-cl-card-pc-wrapper": {
      borderRadius: "5px",
      boxShadow: "0px 2px 5px #cccccc",
      width: "100%"
    },
    ".csui-cl-card-pc-creative-wrapper": {
      height: previewHeight,
      textAlign: "center",
      backgroundColor: "black",
      position: "relative",
      maxHeight: previewHeight,
      borderRadius: "5px 5px 0 0"
    },
    ".csui-cl-card-pc-video-screen-wrapper": {
      position: "relative",
      width: "100%",
      height: "100%"
    },
    ".csui-cl-card-pc-img-screen-wrapper": {
      objectFit: "contain",
      width: "100%",
      height: "100%"
    },
    ".csui-cl-card-pc-icon-wrapper": {
      position: "absolute",
      top: "0.5rem",
      left: "0.5rem",
      // backgroundColor: white, // todo: white? 'transparent'?
      color: "#00a46e",
      width: "90%",
      backgroundColor: "transparent",
      zIndex: "10"
    },
    ".csui-cl-card-pc-video-duration": {
      position: "absolute",
      bottom: 0,
      right: 0,
      backgroundColor: "#000",
      color: "#fff",
      zIndex: "10",
      fontSize: 12,
      padding: 3,
      fontWeight: "bold",
      borderRadius: 2,
      textAlign: "center",
      margin: 4
    },
    ".csui-cl-card-pc-video-thumbnail": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      borderRadius: "5px 5px 0 0"
    },
    ".csui-cl-card-pc-video-thumbnail-wrapper": {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      borderRadius: "5px 5px 0 0",
      position: "absolute",
      top: 0,
      left: 0,
      opacity: "1",
      zIndex: "5"
    },
    ".csui-cl-card-pc-video-thumbnail-wrapper.hide": {
      animation: fadeOut + " 3s ease",
      animationFillMode: "forwards"
    },
    ".csui-cl-card-pc-view": (_a = {}, _a[getMediaquery("sp")] = {
      display: "none"
    }, _a),
    ".csui-cl-card-pc-info-wrapper": {
      padding: "16px",
      display: "flex",
      flexDirection: "column"
    },
    ".csui-cl-card-pc-video-title": {
      fontWeight: "bold",
      marginBottom: "10px",
      display: "-webkit-box",
      "-webkit-box-orient": "vertical",
      "-webkit-line-clamp": "2",
      overflow: "hidden",
      overflowWrap: "anywhere"
    },
    ".csui-cl-card-pc-content-type": {
      marginBottom: 6,
      width: "fit-content",
      height: "fit-content",
      fontSize: "0.6rem",
      color: "grey",
      border: "1px solid grey",
      borderRadius: 4,
      padding: "1px 4px",
      verticalAlign: "middle"
    },
    ".csui-cl-card-pc-video-time": {
      color: "gray",
      marginBottom: "10px"
    },
    ".csui-cl-card-pc-hacker-info-wrapper": {
      display: "flex",
      paddingRight: "12px"
    },
    ".csui-cl-card-pc-avatar-link": {
      margin: "auto 0"
    },
    ".csui-cl-card-pc-avatar-img": {
      width: "30px",
      borderRadius: "50%",
      margin: "0 auto"
    },
    ".csui-cl-card-pc-hacker-name": {
      paddingLeft: "10px",
      fontWeight: "bold",
      display: "inline-block",
      margin: "auto 0"
    },
    ".csui-cl-card-pc-tag-wrapper": {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "10px"
    },
    ".csui-cl-card-pc-footer-content": {
      display: "flex",
      justifyContent: "space-between",
      margin: "auto 0",
      width: "85%"
    },
    ".csui-cl-card-pc-footer-wrapper": {
      display: "flex",
      justifyContent: "space-between",
      paddingTop: "20px"
    },
    ".csui-cl-card-pc-tag-icon-wrapper": {
      position: "relative",
      cursor: "pointer",
      display: "inline-block",
      "&:hover .csui-cl-card-pc-tag-tool-tip-description": {
        display: "inline-block",
        top: "-15px",
        left: "-55px"
      }
    },
    ".csui-cl-card-pc-tag-tool-tip-description": {
      display: "none",
      position: "absolute",
      padding: "5px",
      fontSize: "8px",
      lineHeight: "1em",
      color: "#fff",
      borderRadius: "5px",
      background: "gray",
      whiteSpace: "nowrap",
      width: "80px",
      textAlign: "center"
    },
    ".csui-cl-card-pc-tag-span": {
      borderRadius: "5px",
      backgroundColor: "#99dc92",
      display: "inline-block",
      padding: "4px 10px",
      marginRight: "5px"
    }
  };
};
var fadeOut = keyframes(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    z-index: 0;\n  }\n"], ["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    z-index: 0;\n  }\n"])));
var templateObject_1$6;

var DEFAULT_ASPECT_RATIO = 0.56;
var DEFAULT_PREVIEW_WIDTH = 345;
var DEFAULT_PREVIEW_HEIGHT = DEFAULT_PREVIEW_WIDTH * DEFAULT_ASPECT_RATIO;
var CreativeListCard = function CreativeListCard(_a) {
  var _b;

  var data = _a.data,
      config = _a.config,
      _c = _a.cols,
      cols = _c === void 0 ? 4 : _c,
      isSelectable = _a.isSelectable,
      displayProperties = _a.displayProperties,
      needOpenPreviewModal = _a.needOpenPreviewModal,
      needOpenTagEditModal = _a.needOpenTagEditModal,
      needVideoDuration = _a.needVideoDuration,
      cardFooterElement = _a.cardFooterElement,
      overrideCss = _a.overrideCss,
      onClickCard = _a.onClickCard,
      needVideoControl = _a.needVideoControl,
      kaizenPlayerCss = _a.kaizenPlayerCss,
      thumbnailHoverMinimumMillisecond = _a.thumbnailHoverMinimumMillisecond;
  var isMobile = useAdSearchPageStateContext().isMobile;
  var previewWrapperEl = useRef(null);

  var _d = useState(DEFAULT_PREVIEW_HEIGHT),
      previewHeight = _d[0],
      setPreviewHeight = _d[1];

  var _e = useState(true),
      isFirstRender = _e[0],
      setIsFirstRender = _e[1];

  var changePreviewHeight = useCallback(function () {
    var el = previewWrapperEl.current;
    if (!(el instanceof HTMLDivElement)) return;
    var width = el.getBoundingClientRect().width;
    var height = width * DEFAULT_ASPECT_RATIO;
    setPreviewHeight(height);
  }, []);
  useEffect(function () {
    changePreviewHeight();
  }, []);
  useEffect(function () {
    window.addEventListener("resize", function () {
      return changePreviewHeight();
    });
    return function () {
      window.removeEventListener("resize", function () {
        return changePreviewHeight();
      });
    };
  }, []);
  return /*#__PURE__*/React.createElement(Wrapper$8, {
    className: "csui-cl-card-wrapper",
    isMobile: isMobile,
    cols: cols,
    aspectRatio: (_b = data.aspectRatio) !== null && _b !== void 0 ? _b : "",
    overrideCss: overrideCss,
    isContentTypeMixed: false,
    previewHeight: previewHeight,
    ref: previewWrapperEl
  }, isMobile ? /*#__PURE__*/React.createElement(CreativeListCardMobile, {
    creative: data,
    onClickCard: onClickCard
  }) : /*#__PURE__*/React.createElement(CreativeListCardPc, {
    data: data,
    config: config,
    isSelectable: isSelectable,
    displayProperties: displayProperties,
    needOpenPreviewModal: needOpenPreviewModal,
    needOpenTagEditModal: needOpenTagEditModal,
    cardFooterElement: cardFooterElement,
    needVideoControl: needVideoControl,
    kaizenPlayerCss: kaizenPlayerCss,
    isFirstRender: isFirstRender,
    setIsFirstRender: setIsFirstRender,
    onClickCard: onClickCard,
    thumbnailHoverMinimumMillisecond: thumbnailHoverMinimumMillisecond,
    needVideoDuration: needVideoDuration
  }));
};
var Wrapper$8 = styled("div")(function (_a) {
  var isMobile = _a.isMobile,
      cols = _a.cols,
      aspectRatio = _a.aspectRatio,
      isContentTypeMixed = _a.isContentTypeMixed,
      overrideCss = _a.overrideCss,
      previewHeight = _a.previewHeight;

  var baseCss = __assign(__assign(__assign(__assign(__assign({
    "&.csui-cl-card-wrapper": {
      width: isMobile ? "calc(50% - 8px)" : "calc((100% - 30*" + cols + "px) / " + cols + ")",
      maxWidth: isMobile ? undefined : "345px",
      margin: isMobile ? "4px" : "8px 15px"
    }
  }, creativeListCardMobileCss(previewHeight)), creativeListCardPcCss(previewHeight)), creativeListCardPcCheckBoxCss), createCreativeListCardPcImageScreenCss(isContentTypeMixed)), createCreativeListCardPcVideoScreenCss(aspectRatio, previewHeight));

  var additionalCss = overrideCss && overrideCss({
    isMobile: isMobile,
    cols: cols,
    isContentTypeMixed: isContentTypeMixed,
    aspectRatio: aspectRatio
  });
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

/**
 * __CreativeList__
 * - creative の一覧を表示するリストです
 * - component `CreativeList` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * @param {ICreativeListProps} props
 * @param {ICreativeListItem[]} props.creatives - GH情報を追加した後のcreative情報
 * @param {ICardProps["config"]} props.config GHプロフィールのURLのオブジェクト
 * @param {ICardProps["onClickCard"]} props.onClickCard - `handleClickCard` を指定（カードをクリック時に発火）
 * @param {ICardProps["cols"]} [props.cols] - 一行に表示するカードの数
 * @param {ICardProps["isSelectable"]} [props.isSelectable] - チェックボックスで選択可能かどうか
 * @param {ICardProps["cardFooterElement"]} [props.cardFooterElement] - カードのフッター拡張領域を使用する場合に使用
 * @param {ICardProps["displayProperties"]} [props.displayProperties] - カードに表示する項目を指定する
 * @param {ICardProps["needOpenPreviewModal"]} [props.needOpenPreviewModal] - カードクリック時にプレビューモーダルの表示が不要ならば false を指定する
 * @param {ICardProps["needOpenTagEditModal"]} [props.needOpenTagEditModal] - タグアイコンクリック時にタグ編集モーダルの表示が不要ならば false を指定する
 * @param {ICardProps["needVideoDuration"]} [props.needVideoDuration] - サムネイルに動画の長さ表示を指定する
 * @param {ICreativeListProps["overrideCss"]} [props.overrideCss]
 * @param {ICreativeListStyledProps["overrideCss"]} [props.overrideCss.wrapper] - リストのラッパー要素について、デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @param {ICardProps["overrideCss"]} [props.overrideCss.card] - リストのカードについて、デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @param {ICardProps["needVideoControl"]} [props.needVideoControl] - videoタグのコントローラーの表示を指定する
 * @param {ICardProps["kaizenPlayerCss"]} [props.kaizenPlayerCss] - KaizenVideoPlayerのCSSを指定
 * @param {ICardProps["onClickCard"]} [props.onClickCard] - リストのカードをクリック時に発火
 * @param {ICardProps["thumbnailHoverMinimumMillisecond"]} [props.thumbnailHoverMinimumMillisecond] - リスト一覧で動画を再生させるための最低サムネイルホバーms数
 * @example
 * import { CreativeList, useCreativeSearch, ICreativeListProps } from 'creative-search-ui';
 *
 * const YourComponent = () => {
 *   const { handleClickCard } = useCreativeSearch({ baseUrl: 'Your api base url'})
 *
 *   return <CreativeList
 *    creatives={yourCreatives}
 *    config={yourConfig}
 *    onClickCard={handleClickCard}
 *    cols={yourCols}
 *    isSelectable={yourIsSelectable}
 *    cardFooterElement={yourCardFooterElement}
 *    displayProperties={yourDisplayProperties}
 *    overrideCss={yourOverrideCss}
 *    needVideoControl={needVideoControl}
 *    needVideoDuration={needVideoDuration}
 *    kaizenPlayerCss={kaizenPlayerCss}
 *    onClickCard={onClickCard}
 *    thumbnailHoverMinimumMillisecond={thumbnailHoverMinimumMillisecond}
 *   />
 * };
 */

var CreativeList = function CreativeList(_a) {
  var creatives = _a.creatives,
      config = _a.config,
      cols = _a.cols,
      isSelectable = _a.isSelectable,
      displayProperties = _a.displayProperties,
      needOpenPreviewModal = _a.needOpenPreviewModal,
      needOpenTagEditModal = _a.needOpenTagEditModal,
      needVideoDuration = _a.needVideoDuration,
      cardFooterElement = _a.cardFooterElement,
      overrideCss = _a.overrideCss,
      _b = _a.needVideoControl,
      needVideoControl = _b === void 0 ? false : _b,
      kaizenPlayerCss = _a.kaizenPlayerCss,
      onClickCard = _a.onClickCard,
      _c = _a.thumbnailHoverMinimumMillisecond,
      thumbnailHoverMinimumMillisecond = _c === void 0 ? 500 : _c;
  var adSearchPageState = useAdSearchPageStateContext();
  if (!adSearchPageState.isWrapped) throw new Error("Provider is missing. Please wrap with CreativeSearchProvider");
  return /*#__PURE__*/React.createElement(Wrapper$7, {
    className: "csui-cl-wrapper",
    overrideCss: overrideCss === null || overrideCss === void 0 ? void 0 : overrideCss.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-cl-inner-wrapper"
  }, creatives.filter(function (creative) {
    return adSearchPageState.isFavFilter ? creative.favorite : true;
  }).map(function (creative) {
    return /*#__PURE__*/React.createElement(CreativeListCard, {
      key: creative.id,
      data: creative,
      config: config,
      cols: cols,
      isSelectable: isSelectable,
      displayProperties: displayProperties,
      needOpenPreviewModal: needOpenPreviewModal,
      needOpenTagEditModal: needOpenTagEditModal,
      cardFooterElement: cardFooterElement,
      overrideCss: overrideCss === null || overrideCss === void 0 ? void 0 : overrideCss.card,
      needVideoControl: needVideoControl,
      kaizenPlayerCss: kaizenPlayerCss,
      onClickCard: onClickCard,
      thumbnailHoverMinimumMillisecond: thumbnailHoverMinimumMillisecond,
      needVideoDuration: needVideoDuration
    });
  })));
};
var Wrapper$7 = styled("div")(function (_a) {
  var overrideCss = _a.overrideCss;
  var baseCss = {
    "&.csui-cl-wrapper": {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    },
    ".csui-cl-inner-wrapper": {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      justifyContent: "start"
    }
  };
  var additionalCss = overrideCss && overrideCss();
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

var initialState = {
  query: undefined,
  duration: undefined,
  aspectRatio: undefined,
  industry: undefined,
  placement: undefined,
  offset: DEFAULT_OFFSET,
  limit: DEFAULT_LIMIT,
  selectedOrganizations: [],
  organizationTag: [],
  includeOtherOrganizations: 1,
  isFavFilter: false,
  contentTypes: [],
  businessRegion: [],
  scope: [],
  service: [],
  isPublishedAtSales: [],
  isCreatedAtSales: 0
};
var SearchQueryStateContext = /*#__PURE__*/createContext(__assign({}, initialState));
var SearchQueryDispatchContext = /*#__PURE__*/createContext({
  dispatch: function dispatch() {
    return null;
  }
});
var useSearchQueryStateContext = function useSearchQueryStateContext() {
  return useContext(SearchQueryStateContext);
};
var useSearchQueryDispatchContext = function useSearchQueryDispatchContext() {
  return useContext(SearchQueryDispatchContext);
};

var ACTION_TYPE = {
  SET_ISLOADING_ACTION: "SET_ISLOADING_ACTION",
  SET_ISLOADED_ACTION: "SET_ISLOADED_ACTION",
  SET_CREATIVE_INDEX_FOR_DIRECTOR_WEB_ACTION: "SET_CREATIVE_INDEX_FOR_DIRECTOR_WEB_ACTION",
  SET_ERROR_ACTION: "SET_ERROR_ACTION",
  SELECT_VIDEOS_ACTION: "SELECT_VIDEOS_ACTION",
  SET_QUERY_CACHE_ACTION: "SET_QUERY_CACHE_ACTION",
  SET_ADSEARCH_ACTION: "SET_ADSEARCH_ACTION",
  UPDATE_CREATIVES: "UPDATE_CREATIVES",
  SET_FETCH_CREATIVE_LIST_STATE_ERR: "SET_FETCH_CREATIVE_LIST_STATE_ERR",
  SET_FETCH_SELECTED_CREATIVES_STATE_ERR: "SET_FETCH_SELECTED_CREATIVES_STATE_ERR",
  SET_POST_ORGANIZATION_TAG_STATE_ERR: "SET_POST_ORGANIZATION_TAG_STATE_ERR",
  SET_DELETE_ORGANIZATION_TAG_STATE_ERR: "SET_DELETE_ORGANIZATION_TAG_STATE_ERR",
  SET_POST_FAVORITE_STATE_ERR: "SET_POST_FAVORITE_STATE_ERR",
  SET_DELETE_FAVORITE_STATE_ERR: "SET_DELETE_FAVORITE_STATE_ERR"
};

var updateCreatives = function updateCreatives(request) {
  return {
    type: ACTION_TYPE.UPDATE_CREATIVES,
    payload: request
  };
};

var setFetchCreativeListState = {
  error: function error(err) {
    return {
      type: ACTION_TYPE.SET_FETCH_CREATIVE_LIST_STATE_ERR,
      payload: err
    };
  }
};
var setFetchSelectedCreativeState = {
  error: function error(err) {
    return {
      type: ACTION_TYPE.SET_FETCH_SELECTED_CREATIVES_STATE_ERR,
      payload: err
    };
  }
};
var setPostOrganizationTagState = {
  error: function error(err) {
    return {
      type: ACTION_TYPE.SET_POST_ORGANIZATION_TAG_STATE_ERR,
      payload: err
    };
  }
};
var setDeleteOrganizationTagState = {
  error: function error(err) {
    return {
      type: ACTION_TYPE.SET_DELETE_ORGANIZATION_TAG_STATE_ERR,
      payload: err
    };
  }
};
var setPostFavoriteState = {
  error: function error(err) {
    return {
      type: ACTION_TYPE.SET_POST_FAVORITE_STATE_ERR,
      payload: err
    };
  }
};
var setDeleteFavoriteState = {
  error: function error(err) {
    return {
      type: ACTION_TYPE.SET_DELETE_FAVORITE_STATE_ERR,
      payload: err
    };
  }
};
var adSearchActions = {
  updateCreatives: updateCreatives,
  setFetchCreativeListState: setFetchCreativeListState,
  setFetchSelectedCreativeState: setFetchSelectedCreativeState,
  setPostOrganizationTagState: setPostOrganizationTagState,
  setDeleteOrganizationTagState: setDeleteOrganizationTagState,
  setPostFavoriteState: setPostFavoriteState,
  setDeleteFavoriteState: setDeleteFavoriteState
};
var reducer$1 = function reducer(state, action) {
  var _a;

  switch (action.type) {
    case "SET_ISLOADING_ACTION":
      {
        return __assign(__assign({}, state), {
          adSearch: __assign(__assign({}, state.adSearch), {
            isLoading: action.payload
          })
        });
      }

    case "SET_ISLOADED_ACTION":
      {
        return __assign(__assign({}, state), {
          adSearch: __assign(__assign({}, state.adSearch), {
            isLoaded: action.payload
          })
        });
      }

    case "SET_CREATIVE_INDEX_FOR_DIRECTOR_WEB_ACTION":
      {
        return __assign(__assign({}, state), {
          adSearch: __assign(__assign({}, state.adSearch), {
            data: __assign(__assign({}, state.adSearch.data), action.payload)
          })
        });
      }

    case "SET_ERROR_ACTION":
      {
        return __assign(__assign({}, state), {
          adSearch: __assign(__assign({}, state.adSearch), action.payload)
        });
      }

    case "SELECT_VIDEOS_ACTION":
      {
        return __assign(__assign({}, state), {
          adSearch: __assign(__assign({}, state.adSearch), {
            isLoading: false,
            isLoaded: true,
            selectedVideos: action.payload
          })
        });
      }

    case "SET_QUERY_CACHE_ACTION":
      {
        return __assign(__assign({}, state), {
          adSearch: __assign(__assign({}, state.adSearch), action.payload)
        });
      }

    case "SET_ADSEARCH_ACTION":
      {
        return __assign(__assign({}, state), {
          adSearch: __assign(__assign({}, state.adSearch), action.payload)
        });
      }

    case "UPDATE_CREATIVES":
      {
        if (!((_a = state.adSearch.data) === null || _a === void 0 ? void 0 : _a.creatives)) throw new Error("invalid creatives");
        return __assign(__assign({}, state), {
          adSearch: __assign(__assign({}, state.adSearch), {
            data: __assign(__assign({}, state.adSearch.data), {
              creatives: action.payload
            })
          })
        });
      }

    case ACTION_TYPE.SET_FETCH_CREATIVE_LIST_STATE_ERR:
      {
        return __assign(__assign({}, state), {
          fetchCreativeListState: __assign(__assign({}, state.fetchCreativeListState), {
            error: action.payload
          })
        });
      }

    case ACTION_TYPE.SET_FETCH_SELECTED_CREATIVES_STATE_ERR:
      {
        return __assign(__assign({}, state), {
          fetchSelectedCreativesState: __assign(__assign({}, state.fetchSelectedCreativesState), {
            error: action.payload
          })
        });
      }

    case ACTION_TYPE.SET_POST_ORGANIZATION_TAG_STATE_ERR:
      {
        return __assign(__assign({}, state), {
          postOrganizationTagState: __assign(__assign({}, state.postOrganizationTagState), {
            error: action.payload
          })
        });
      }

    case ACTION_TYPE.SET_DELETE_ORGANIZATION_TAG_STATE_ERR:
      {
        return __assign(__assign({}, state), {
          deleteOrganizationTagState: __assign(__assign({}, state.deleteOrganizationTagState), {
            error: action.payload
          })
        });
      }

    case ACTION_TYPE.SET_POST_FAVORITE_STATE_ERR:
      {
        return __assign(__assign({}, state), {
          postFavoriteState: __assign(__assign({}, state.postFavoriteState), {
            error: action.payload
          })
        });
      }

    case ACTION_TYPE.SET_DELETE_FAVORITE_STATE_ERR:
      {
        return __assign(__assign({}, state), {
          deleteFavoriteState: __assign(__assign({}, state.deleteFavoriteState), {
            error: action.payload
          })
        });
      }

    default:
      throw new Error();
  }
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "SET_LOCALE":
      {
        return __assign(__assign({}, state), {
          locale: action.payload
        });
      }

    default:
      throw new Error();
  }
};

/**
 * __CreativeSearchProvider__
 * - creative-search-uiで提供されるコンテキストのプロバイダーです。
 * - creative-search-uiで提供される component を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * @param {ICreativeSearchProviderProps} props
 * @param {ICreativeSearchProviderProps["locale"]} props.locale - creative-search-ui使用側で設定されているロケール情報
 * @param {businessRegion[]} props.businessRegion - 検索対象となるビジネス地域情報
 * @example
 * import { CreativeSearchProvider } from 'creative-search-ui';
 *
 * const YourComponent = () => {
 *
 *  return (
 *   <CreativeSearchProvider
 *    locale={yourLocale}
 *    businessRegion={yourBusinessRegion}
 *   >
 *      <yourChildComponent />
 *   </CreativeSearchProvider>
 *  )};
 */

var CreativeSearchProvider = function CreativeSearchProvider(_a) {
  var _b = _a.locale,
      locale = _b === void 0 ? "ja" : _b,
      children = _a.children,
      _c = _a.businessRegion,
      businessRegion = _c === void 0 ? ["jp"] : _c;

  var _d = useReducer(reducer, __assign(__assign({}, initialState$1), {
    locale: locale
  })),
      localeState = _d[0],
      localeDispatch = _d[1];

  var _e = useReducer(reducer$2, __assign(__assign({}, initialState$3), {
    isWrapped: true
  })),
      adSearchPageState = _e[0],
      adSearchPageDispatch = _e[1];

  var _f = useReducer(reducer$1, __assign({}, initialState$2)),
      adSearchState = _f[0],
      adSearchDispatch = _f[1];

  var _g = useState(initialState),
      searchQueryState = _g[0],
      searchQueryDispatch = _g[1];

  return /*#__PURE__*/React.createElement(LocaleStateContext.Provider, {
    value: __assign({}, localeState)
  }, /*#__PURE__*/React.createElement(LocaleDispatchContext.Provider, {
    value: {
      dispatch: localeDispatch
    }
  }, /*#__PURE__*/React.createElement(AdSearchPageStateContext.Provider, {
    value: __assign({}, adSearchPageState)
  }, /*#__PURE__*/React.createElement(AdSearchPageDispatchContext.Provider, {
    value: {
      dispatch: adSearchPageDispatch
    }
  }, /*#__PURE__*/React.createElement(AdSearchStateContext.Provider, {
    value: __assign({}, adSearchState)
  }, /*#__PURE__*/React.createElement(AdSearchDispatchContext.Provider, {
    value: {
      dispatch: adSearchDispatch
    }
  }, /*#__PURE__*/React.createElement(SearchQueryStateContext.Provider, {
    value: __assign(__assign({}, searchQueryState), {
      businessRegion: businessRegion
    })
  }, /*#__PURE__*/React.createElement(SearchQueryDispatchContext.Provider, {
    value: {
      dispatch: searchQueryDispatch
    }
  }, children))))))));
};

var useFilterContext = function useFilterContext() {
  var seachQueryCacheState = useSearchQueryStateContext();
  var seachQueryCache = useSearchQueryDispatchContext();

  var _a = useAdSearchPageStateContext(),
      selectedPlacement = _a.selectedPlacement,
      selectedDuration = _a.selectedDuration,
      selectedAspect = _a.selectedAspect,
      selectedIndustry = _a.selectedIndustry,
      includeOtherOrganizations = _a.includeOtherOrganizations,
      selectedOrganizations = _a.selectedOrganizations,
      selectedOrganizationTags = _a.selectedOrganizationTags,
      isFavFilter = _a.isFavFilter,
      selectdContentTypes = _a.selectdContentTypes;

  var dispatch = useAdSearchPageDispatchContext().dispatch;
  var selectPlacementAction = adSearchPageActions.selectPlacementAction,
      selectDurationAction = adSearchPageActions.selectDurationAction,
      selectAspectAction = adSearchPageActions.selectAspectAction,
      selectIndustryAction = adSearchPageActions.selectIndustryAction,
      setIncludeOtherOrganizations = adSearchPageActions.setIncludeOtherOrganizations,
      selectOrganizationsAction = adSearchPageActions.selectOrganizationsAction,
      selectOrganizationTagsAction = adSearchPageActions.selectOrganizationTagsAction,
      setIsFavFilter = adSearchPageActions.setIsFavFilter,
      selectContentType = adSearchPageActions.selectContentType;

  var saveFavFilterCache = function saveFavFilterCache(filterState) {
    var cache = __assign(__assign({}, seachQueryCacheState), {
      isFavFilter: filterState
    });

    seachQueryCache.dispatch(cache);
  };

  var setFilter = useCallback(function (arg) {
    switch (arg.key) {
      case "placement":
        dispatch(selectPlacementAction(arg.value));
        break;

      case "duration":
        dispatch(selectDurationAction(arg.value));
        break;

      case "aspectRatio":
        dispatch(selectAspectAction(arg.value));
        break;

      case "industry":
        dispatch(selectIndustryAction(arg.value));
        break;

      case "includeOtherOrganizations":
        dispatch(setIncludeOtherOrganizations(arg.value));
        break;

      case "organizationId":
        dispatch(selectOrganizationsAction(arg.value));
        break;

      case "organizationTag":
        dispatch(selectOrganizationTagsAction(arg.value));
        break;

      case "isFavFilter":
        dispatch(setIsFavFilter(arg.value));
        saveFavFilterCache(arg.value);
        break;

      case "contentType":
        dispatch(selectContentType(arg.value));
        break;
    }
  }, []);
  return {
    state: {
      selectedPlacement: selectedPlacement,
      selectedDuration: selectedDuration,
      selectedAspect: selectedAspect,
      selectedIndustry: selectedIndustry,
      selectedOrganizations: selectedOrganizations,
      selectedOrganizationTags: selectedOrganizationTags,
      includeOtherOrganizations: includeOtherOrganizations,
      isFavFilter: isFavFilter,
      selectdContentTypes: selectdContentTypes
    },
    methods: {
      setFilter: setFilter
    }
  };
};

var FilterIcon = function FilterIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root$5, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    className: className,
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
  }));
};
var Root$5 = styled("svg")(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  vertical-align: middle;\n  display: block;\n  height: 100%;\n"], ["\n  vertical-align: middle;\n  display: block;\n  height: 100%;\n"])));
var templateObject_1$5;

var _a;
/**
 * __PcSearchFilterWrapper__
 * component `PcSearchFilterWrapper` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * @example
 *  <PcSearchFilterWrapper>
 *    //filter child component
 *  </PcSearchFilterWrapper>
 */

var PcSearchFilterWrapper = function PcSearchFilterWrapper(props) {
  var _a = useState(false),
      isExpanded = _a[0],
      setExpand = _a[1];

  var t = useTranslation().t;

  var taggleFilter = function taggleFilter() {
    setExpand(!isExpanded);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "csui-fil-pc-wr-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-fil-pc-wr-icon-wrapper",
    onClick: taggleFilter
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-fil-pc-wr-filter-icon"
  }, /*#__PURE__*/React.createElement(FilterIcon, {
    size: 24
  })), /*#__PURE__*/React.createElement("p", {
    className: "csui-fil-pc-wr-filter-text"
  }, t("searchFilter.filter"))), /*#__PURE__*/React.createElement("div", {
    className: isExpanded ? "csui-fil-pc-wr-filter-body" : "csui-fil-pc-wr-filter-body csui-fil-pc-wr-is-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-fil-pc-wr-filter-contents"
  }, props.children)));
};
var pcSearchFilterWrapperCss = {
  ".csui-fil-pc-wr-wrapper": (_a = {}, _a[getMediaquery("sp")] = {
    display: "none"
  }, _a),
  ".csui-fil-pc-wr-filter-icon": {
    cursor: "pointer" // cursor: hand,

  },
  ".csui-fil-pc-wr-filter-text": {
    display: "block",
    margin: "auto 0"
  },
  ".csui-fil-pc-wr-icon-wrapper": {
    padding: "2px 4px",
    display: "flex",
    marginTop: "30px",
    verticalAlign: "middle",
    cursor: "pointer" // cursor: hand,

  },
  ".csui-fil-pc-wr-filter-body": {
    transition: "padding-top 300ms, line-height 300ms",
    padding: "5px 15px 15px 15px",
    backgroundColor: "transparent",
    borderRadius: "5px",
    overflow: "auto",
    "&.csui-fil-pc-wr-is-hidden": {
      paddingTop: "0",
      paddingBottom: "0",
      lineHeight: "0",
      pointerEvents: "none",
      height: "0"
    }
  },
  ".csui-fil-pc-wr-filter-contents": {
    display: "flex",
    alignItems: "left",
    padding: "2px 4px",
    justifyContent: "space-between"
  },
  ".csui-fil-pc-wr-is-hidden": {
    opacity: "0",
    pointerEvents: "none"
  }
};

/**
 * __PcSearchFilterChild__
 * component `PcSearchFilterChild` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * @param facet フィルターの絞込み条件のオブジェクト
 * @example
 *   <PcSearchFilterChild facet={FACET}></PcSearchFilterChild>
 */

var PcSearchFilterChild = function PcSearchFilterChild(props) {
  var AdSearchPageState = useAdSearchPageStateContext();
  var dispatch = useAdSearchPageDispatchContext().dispatch;
  var seachQueryCacheState = useSearchQueryStateContext();
  var seachQueryCache = useSearchQueryDispatchContext();
  var filterState = useFilterContext().state;

  var _a = useState(),
      checkedValues = _a[0],
      setCheckedValues = _a[1];

  var setValues = useCallback(function () {
    var _a, _b, _c, _d;

    switch (props.facet.apiQueryValue) {
      case "industry":
        setCheckedValues([(_a = filterState.selectedIndustry) !== null && _a !== void 0 ? _a : ""]);
        break;

      case "aspectRatio":
        setCheckedValues([(_b = filterState.selectedAspect) !== null && _b !== void 0 ? _b : ""]);
        break;

      case "placement":
        setCheckedValues([(_c = filterState.selectedPlacement) !== null && _c !== void 0 ? _c : ""]);
        break;

      case "duration":
        setCheckedValues([(_d = filterState.selectedDuration) !== null && _d !== void 0 ? _d : ""]);
        break;

      case "organizationId":
        filterState.includeOtherOrganizations === 1 ? setCheckedValues([""]) : setCheckedValues(["1494"]);
        break;

      case "organizationTag":
        setCheckedValues(Array.isArray(filterState.selectedOrganizationTags) ? filterState.selectedOrganizationTags : []);
        break;

      case "favorite":
        setCheckedValues(filterState.isFavFilter ? [""] : []);
        break;

      case "contentType":
        setCheckedValues(filterState.selectdContentTypes);
        break;

      default:
        throw new Error("invalid query value");
    }
  }, []);
  useEffect(function () {
    setValues();
  }, [setValues]);
  /**
   * プレースメント選択のセレクトボックスを選択した時に発火するメソッド
   * @param e イベントオブジェクト
   */

  var handleClickPlacement = function handleClickPlacement(e, selectedValue) {
    setCheckedValues([selectedValue]);
    dispatch(adSearchPageActions.selectPlacementAction(selectedValue));
  };
  /**
   * 秒数選択のセレクトボックスを選択した時に発火するメソッド
   * @param e イベントオブジェクト
   */


  var handleClickDuration = function handleClickDuration(e, selectedValue) {
    setCheckedValues([selectedValue]);
    dispatch(adSearchPageActions.selectDurationAction(selectedValue));
  };
  /**
   * タテヨコ比選択のセレクトボックスを選択した時に発火するメソッド
   * @param e イベントオブジェクト
   */


  var handleClickAspect = function handleClickAspect(e, selectedValue) {
    setCheckedValues([selectedValue]);
    dispatch(adSearchPageActions.selectAspectAction(selectedValue));
  };
  /**
   * 業種選択のセレクトボックスを選択した時に発火するメソッド
   * @param e イベントオブジェクト
   */


  var handleClickIndustry = function handleClickIndustry(e, selectedValue) {
    setCheckedValues([selectedValue]);
    dispatch(adSearchPageActions.selectIndustryAction(selectedValue));
  };
  /**
   * 組織を選択されたときに発火する。
   * 既に選択されていた組織なら解除する。
   * @param e
   */


  var handleSelectedOrganizations = function handleSelectedOrganizations(e, value) {
    setCheckedValues([value]); // label表示用に "" をmenuに混ぜているのでそれをデータ送信前に取り除く意図でfilterしている

    var selectedValue = [];
    selectedValue.push(value);
    // 個別組織のチェックを全て外した場合は「公開事例」にチェックをつける

    if (selectedValue.length === 0) {
      dispatch(adSearchPageActions.onIncludeOtherOrganizations());
    } // 個別組織にチェックが入っている場合は「公開事例」のチェックを外す
    else {
        dispatch(adSearchPageActions.offIncludeOtherOrganizations());
      }

    dispatch(adSearchPageActions.selectOrganizationsAction(selectedValue.filter(function (v) {
      return v !== "";
    })));
    return;
  };

  var saveFavFilterCache = function saveFavFilterCache(filterState) {
    var cache = __assign(__assign({}, seachQueryCacheState), {
      isFavFilter: filterState
    });

    seachQueryCache.dispatch(cache);
  };
  /**
   * favを選択されたときに発火する。
   * 既に選択されていたら解除する。
   * @param e
   */


  var handleFavFilter = function handleFavFilter(e, selectedValue) {
    if (checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes(selectedValue)) {
      var newValues = checkedValues.concat();
      var index = newValues.indexOf(selectedValue);
      newValues.splice(index, 1);
      setCheckedValues(newValues);
    } else {
      var newValues = checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.concat();
      newValues === null || newValues === void 0 ? void 0 : newValues.push(selectedValue);
      setCheckedValues(newValues);
    }

    dispatch(adSearchPageActions.toggleFavFilterAction());
    saveFavFilterCache(!AdSearchPageState.isFavFilter);
  };
  /**
   * contextTypeを選択されたときに発火する。
   * 既に選択されていたら解除する。
   * @param e
   */


  var handleClickContentType = function handleClickContentType(e, clickedValue) {
    setCheckedValues([clickedValue]);
    dispatch(adSearchPageActions.selectContentType([clickedValue]));

    var cache = __assign(__assign({}, seachQueryCacheState), {
      contentTypes: [clickedValue]
    });

    seachQueryCache.dispatch(cache);
  };
  /**
   * タグを選択されたときに発火する。
   * @param e
   */


  var handleSelectedOrganizationTags = function handleSelectedOrganizationTags(e, clickedValue) {
    var newValues;

    if (checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes(clickedValue)) {
      newValues = checkedValues.concat();
      var index = newValues.indexOf(clickedValue);
      newValues.splice(index, 1);
      setCheckedValues(newValues);
    } else {
      newValues = (checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.concat()) || [];
      newValues.push(clickedValue);
      setCheckedValues(newValues);
    }

    dispatch(adSearchPageActions.selectOrganizationTagsAction(newValues));
  };

  var _onClick;

  switch (props.facet.apiQueryValue) {
    case "industry":
      _onClick = handleClickIndustry;
      break;

    case "aspectRatio":
      _onClick = handleClickAspect;
      break;

    case "placement":
      _onClick = handleClickPlacement;
      break;

    case "duration":
      _onClick = handleClickDuration;
      break;

    case "organizationId":
      _onClick = handleSelectedOrganizations;
      break;

    case "organizationTag":
      _onClick = handleSelectedOrganizationTags;
      break;

    case "favorite":
      _onClick = handleFavFilter;
      break;

    case "contentType":
      _onClick = handleClickContentType;
      break;

    default:
      throw new Error("invalid query value");
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "csui-fil-pc-ch-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    className: "csui-fil-pc-ch-category-label"
  }, props.facet.title), /*#__PURE__*/React.createElement("ul", {
    className: "csui-fil-pc-ch-category-ul"
  }, Object.keys(props.facet.value).map(function (key, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: "csui-fil-pc-ch-category-li",
      key: key,
      onClick: function onClick(e) {
        return _onClick(e, props.facet.value[key]);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: (checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes(props.facet.value[key])) ? "csui-fil-pc-ch-list-span csui-fil-pc-ch-clicked csui-fil-pc-ch-category-span" : "csui-fil-pc-ch-list-span"
    }, key), /*#__PURE__*/React.createElement("span", {
      className: (checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes(props.facet.value[key])) ? "csui-fil-pc-ch-checked-icon" : "csui-fil-pc-ch-unchecked-icon"
    }, /*#__PURE__*/React.createElement(CheckIcon, {
      size: 18
    })));
  })));
};
var pcSearchFilterChildCss = {
  ".csui-fil-pc-ch-wrapper": {
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: "column",
    paddingLeft: "20px"
  },
  ".csui-fil-pc-ch-category-label": {
    borderBottom: "2px gray solid",
    padding: "4px 8px 4px 0",
    width: "9rem",
    margin: "0 0 10px 0"
  },
  ".csui-fil-pc-ch-category-ul": {
    margin: "0",
    listStyle: "none",
    paddingLeft: "0px"
  },
  ".csui-fil-pc-ch-category-li": {
    color: "gray",
    fontSize: "0.8rem",
    padding: "10px 0",
    cursor: "pointer",
    // cursor: "hand",
    display: "flex"
  },
  ".csui-fil-pc-ch-list-span": {
    borderRadius: "5px",
    display: "inline-block",
    height: "1.25rem",
    lineHeight: "1.25rem"
  },
  ".csui-fil-pc-ch-clicked": {
    margin: "auto 0"
  },
  ".csui-fil-pc-ch-unchecked-icon": {
    display: "none"
  },
  ".csui-fil-pc-ch-checked-icon": {
    paddingLeft: "5px",
    display: "inline-block",
    height: "0.8rem",
    marginBottom: "0.4rem"
  },
  ".csui-fil-pc-ch-category-span": {
    display: "inline-block",
    height: "1.25rem",
    lineHeight: "1.25rem"
  }
};

/**
 * __SpSearchFilterWrapper__
 * component `SpSearchFilterWrapper` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * @param searchWithCondition 検索をする時に発火するイベント
 * @example

 *
 * import { SpSearchFilterWrapper, useCreativeSearch } from 'creative-search-ui'
 *
 * const YourComponent = () => {
 *   const { searchWithCondition } = useCreativeSearch({ baseUrl: 'Your api base url'})
 *
 *   return (
 *    <SpSearchFilterWrapper
 *      searchWithCondition={searchWithCondition}
 *    >
 *      //filter child component
 *    </SpSearchFilterWrapper>
 * }
 */

var SpSearchFilterWrapper = function SpSearchFilterWrapper(_a) {
  var searchWithCondition = _a.searchWithCondition,
      children = _a.children;
  var isMobile = useAdSearchPageStateContext().isMobile;
  var dispatch = useAdSearchPageDispatchContext().dispatch;
  var searchQueryCacheState = useSearchQueryStateContext();
  var t = useTranslation().t;
  if (!isMobile) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "csui-fil-sp-wr-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-fil-sp-wr-input-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    className: "csui-fil-sp-wr-search-input",
    placeholder: t("keywordForm.placeholder"),
    autoFocus: !isMobile,
    defaultValue: searchQueryCacheState.query ? searchQueryCacheState.query : "",
    onBlur: function onBlur(e) {
      var selectedValue = e.target.value;
      dispatch(adSearchPageActions.inputQueryAction(selectedValue));
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "csui-fil-sp-wr-cancel-span",
    onClick: function onClick() {
      dispatch(adSearchPageActions.setSpSearchModal(false));
    }
  }, t("keywordForm.cancel"))), children, /*#__PURE__*/React.createElement("a", {
    className: "csui-fil-sp-wr-search-button",
    onClick: function onClick() {
      searchWithCondition();
      dispatch(adSearchPageActions.setSpSearchModal(false));
    }
  }, /*#__PURE__*/React.createElement("span", null, t("keywordForm.buttonText"))));
};
var createSpSearchFilterWrapperCss = function createSpSearchFilterWrapperCss(_a) {
  var isOpen = _a.isOpen;
  return {
    ".csui-fil-sp-wr-wrapper": {
      position: "fixed",
      width: "100vw",
      maxHeight: "100vh",
      height: "100%",
      backgroundColor: "white",
      top: "0",
      left: "0",
      zIndex: "3",
      padding: "12px",
      paddingTop: "62px",
      transition: "all 0.3s ease-in-out 0s",
      transform: isOpen ? "translateY(0%)" : "translateY(-100%)",
      display: "flex",
      flexDirection: "column",
      overflow: "auto"
    },
    ".csui-fil-sp-wr-input-wrapper": {
      display: "flex",
      justifyContent: "space-between"
    },
    ".csui-fil-sp-wr-search-input": {
      outline: "none",
      border: "none",
      borderBottom: "gray solid 1px",
      margin: "15px 0",
      padding: "5px 0",
      width: "65%"
    },
    ".csui-fil-sp-wr-cancel-span": {
      display: "block",
      margin: "auto 0",
      fontSize: "14px"
    },
    ".csui-fil-sp-wr-search-button": {
      display: "flex",
      justifyContent: "center",
      position: "relative",
      margin: "10px auto",
      textAlign: "center",
      verticalAlign: "middle",
      backgroundColor: "#04a46f",
      width: "100%",
      borderRadius: "4px",
      color: "#fff",
      lineHeight: "32px",
      WebkitTransition: "none",
      transition: "none",
      boxShadow: "0 3px 0 #0e8c73",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)",
      "&:hover": {
        backgroundColor: "#31c8aa",
        boxShadow: "0 3px 0 #23a188"
      },
      "&:active": {
        top: "3px",
        boxShadow: "none"
      }
    }
  };
};

/**
 * __SpSearchFilterChild__
 * component `SpSearchFilterChild` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * @param facet フィルターの絞込み条件のオブジェクト
 * @example
 *   <SpSearchFilterChild facet={FACET}></SpSearchFilterChild>
 */

var SpSearchFilterChild = function SpSearchFilterChild(props) {
  var dispatch = useAdSearchPageDispatchContext().dispatch;

  var _onChange;
  /**
   * プレースメント選択のセレクトボックスを選択した時に発火するメソッド
   * @param e イベントオブジェクト
   */


  var handleClickPlacement = function handleClickPlacement(e) {
    dispatch(adSearchPageActions.selectPlacementAction(e.target.value));
  };
  /**
   * 秒数選択のセレクトボックスを選択した時に発火するメソッド
   * @param e イベントオブジェクト
   */


  var handleClickDuration = function handleClickDuration(e) {
    dispatch(adSearchPageActions.selectDurationAction(e.target.value));
  };
  /**
   * タテヨコ比選択のセレクトボックスを選択した時に発火するメソッド
   * @param e イベントオブジェクト
   */


  var handleClickAspect = function handleClickAspect(e) {
    dispatch(adSearchPageActions.selectAspectAction(e.target.value));
  };
  /**
   * 業種選択のセレクトボックスを選択した時に発火するメソッド
   * @param e イベントオブジェクト
   */


  var handleClickIndustry = function handleClickIndustry(e) {
    dispatch(adSearchPageActions.selectIndustryAction(e.target.value));
  };

  switch (props.facet.apiQueryValue) {
    case "industry":
      _onChange = handleClickIndustry;
      break;

    case "aspectRatio":
      _onChange = handleClickAspect;
      break;

    case "placement":
      _onChange = handleClickPlacement;
      break;

    case "duration":
      _onChange = handleClickDuration;
      break;

    default:
      throw new Error("invalid query value");
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "csui-fil-sp-ch-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    className: "csui-fil-sp-ch-filter-label",
    htmlFor: ""
  }, props.facet.title), /*#__PURE__*/React.createElement("select", {
    className: "csui-fil-sp-ch-filter-select",
    onChange: function onChange(e) {
      _onChange(e);
    }
  }, Object.keys(props.facet.value).map(function (key) {
    return /*#__PURE__*/React.createElement("option", {
      value: props.facet.value[key],
      key: key
    }, key);
  })));
};
var spSearchFilterChildCss = {
  ".csui-fil-sp-ch-wrapper": undefined,
  ".csui-fil-sp-ch-filter-label": {
    fontSize: "14px"
  },
  ".csui-fil-sp-ch-filter-select": {
    border: "none",
    borderBottom: "solid 1px black",
    outline: "none",
    display: "block",
    padding: "6px 0 7px",
    margin: "10px 0",
    width: "100%",
    "&:hover": {
      borderBottom: "solid 2px green"
    },
    "&:focus": {
      borderBottom: "green solid 2px",
      backgroundColor: "#f2f2f2"
    }
  }
};

var setNextState = function setNextState(selectedOrganizations, checkedList, isPublicCreativesSelected, nextState, departmentIds) {
  if (isStrArray(checkedList)) {
    if (selectedOrganizations.length === 0 && isPublicCreativesSelected) {
      // 公開事例にのみチェックが入っていた状態でイベントが発生した時
      nextState.isPublic = false; // 公開事例、組織のどちらがクリックされた場合でも公開事例のチェックを外す

      nextState.dispatchedIds = checkedList.length === 0 ? departmentIds // checkedList長が0と言うことは公開事例がクリックされたと言うことなので、全ての組織にチェックをいれる
      : checkedList.filter(function (val) {
        return val !== SELECT_KOUKAIZIREI_KEY;
      }); // checkedList長が正（2のみ）と言うことは組織がチェックされたと言うことなので、その組織にチェックを入れる
    }

    if (selectedOrganizations.length > 0 && !isPublicCreativesSelected) {
      // （公開事例にチェックは入っておらず）いずれかの組織にチェックが入っていた状態でイベントが発生した時
      if (checkedList.length > 0) {
        // checkedList長が正の時
        if (!checkedList.includes(SELECT_KOUKAIZIREI_KEY)) {
          // 公開事例の値が含まれていなければ、個別の組織がチェックされたと言うことなので、公開事例は解除し、その組織にチェックを入れる
          nextState.isPublic = false;
          nextState.dispatchedIds = checkedList.filter(function (val) {
            return val !== SELECT_KOUKAIZIREI_KEY;
          });
        }
      }
    }
  }
};

/**
 * __Filter__
 * - 検索フィルターです
 * - component `KeywordForm` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * @param {IFilterProps} props
 * @param {SpSearchFilterWrapperProps["searchWithCondition"]} props.searchWithCondition - `searchWithCondition` を指定（Mobile用フィルターで、検索ボタンクリック時に発火）。
 * @param {IFacet[]} [props.facetList] - フィルタとして使用する facet の配列を指定。contentRender を使用する場合には不要。
 * @param {ExtendedOrganization[]} [props.department] - hugot-director-webclient での使用を想定した prop で、必要に応じて ExtendedOrganization[] を受け取ることが可能。contentRender で department を使用する場合には指定が必須。
 * @param {(args: IContentRenderArgs) => JSX.Element} [props.contentRender] - IContentRenderArgs を使用して、独自のUIコンポーネントをレンダリングしたい場合に使用
 * @param {IFilterStyledProps["overrideCss"]} [props.overrideCss] - デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @example
 * import { Filter, useCreativeSearch, IFilterProps } from 'creative-search-ui'
 *
 * const YourComponent = () => {
 *   const { searchWithCondition } = useCreativeSearch({ baseUrl: 'Your api base url'})
 *
 *   return <Filter
 *     searchWithCondition={searchWithCondition}
 *     facetList={yourFacetList}
 *     contentRender={(contentRenderArgs) => <YourFilterUIComponent {...contentRenderArgs} />}
 *     overrideCss={yourOverrideCss}
 *   />
 * }
 */

var Filter = function Filter(_a) {
  var searchWithCondition = _a.searchWithCondition,
      _b = _a.facetList,
      facetList = _b === void 0 ? [] : _b,
      _c = _a.department,
      department = _c === void 0 ? [] : _c,
      contentRender = _a.contentRender,
      overrideCss = _a.overrideCss;
  var isOpenSearchMobileModal = useAdSearchPageStateContext().isOpenSearchMobileModal;
  var dispatch = useAdSearchPageDispatchContext().dispatch;

  var _d = useFilterContext(),
      filterState = _d.state,
      setFilter = _d.methods.setFilter;

  var selectedOrganizations = filterState.selectedOrganizations,
      isFavFilter = filterState.isFavFilter;

  var handleSelect = function handleSelect(e, queryKey) {
    var val = e.target.value;
    var dispatchedVal = val !== defaultSelected[queryKey] && typeof val === "string" && val.length > 0 ? val : "";

    if (dispatchedVal === "" && queryKey === "aspectRatio") {
      dispatch(adSearchPageActions.setIsOriginal(true));
    } else {
      dispatch(adSearchPageActions.setIsOriginal(undefined));
    }

    setFilter({
      key: queryKey,
      value: dispatchedVal
    });
  };

  var handleChangePlacement = function handleChangePlacement(e) {
    handleSelect(e, "placement");
  };

  var handleChangeDuration = function handleChangeDuration(e) {
    handleSelect(e, "duration");
  };

  var handleChangeAspect = function handleChangeAspect(e) {
    handleSelect(e, "aspectRatio");
  };

  var handleChangeIndustry = function handleChangeIndustry(e) {
    handleSelect(e, "industry");
  };

  var _e = useState(true),
      isPublicCreativesSelected = _e[0],
      setIsPublicCreativesSelected = _e[1];

  var handleSelectedOrganizations = function handleSelectedOrganizations(e) {
    var checkedList = e.target.value;
    var departmentIds = department.map(function (d) {
      return d.id;
    });
    var nextState = {
      isPublic: true,
      dispatchedIds: []
    }; // デフォルトの nextState

    setNextState(selectedOrganizations, checkedList, isPublicCreativesSelected, nextState, departmentIds); // 上記の場合以外はデフォルトの nextStateのまま

    setIsPublicCreativesSelected(nextState.isPublic);
    setFilter({
      key: "organizationId",
      value: nextState.dispatchedIds
    });
    return isPublicCreativesSelected;
  };

  var handleSelectedTags = function handleSelectedTags(value) {
    setFilter({
      key: "organizationTag",
      value: value
    });
  };

  var handleFavFilter = function handleFavFilter(_) {
    setFilter({
      key: "isFavFilter",
      value: !isFavFilter
    });
  };

  var getFilterClickHandler = function getFilterClickHandler(queryKey) {
    switch (queryKey) {
      case "placement":
        return handleChangePlacement;

      case "duration":
        return handleChangeDuration;

      case "aspectRatio":
        return handleChangeAspect;

      case "industry":
        return handleChangeIndustry;

      case "organizationId":
        return handleSelectedOrganizations;

      case "favorite":
        return handleFavFilter;

      default:
        throw new Error("invalid query key provided");
    }
  };

  if (contentRender) return contentRender({
    getFilterClickHandler: getFilterClickHandler,
    handleSelectedTags: handleSelectedTags,
    filterState: filterState,
    defaultSelected: defaultSelected,
    SELECT_KOUKAIZIREI_KEY: SELECT_KOUKAIZIREI_KEY,
    isPublicCreativesSelected: isPublicCreativesSelected,
    department: department
  });
  return /*#__PURE__*/React.createElement(Wrapper$6, {
    className: "csui-fil-wrapper",
    isOpenSearchMobileModal: isOpenSearchMobileModal,
    overrideCss: overrideCss
  }, /*#__PURE__*/React.createElement(PcSearchFilterWrapper, null, facetList.map(function (f) {
    return /*#__PURE__*/React.createElement(PcSearchFilterChild, {
      key: f.apiQueryValue,
      facet: f
    });
  })), /*#__PURE__*/React.createElement(SpSearchFilterWrapper, {
    searchWithCondition: searchWithCondition
  }, facetList.map(function (f) {
    switch (f.apiQueryValue) {
      case "aspectRatio":
      case "duration":
      case "industry":
      case "placement":
        return /*#__PURE__*/React.createElement(SpSearchFilterChild, {
          key: f.apiQueryValue + "ForMobile",
          facet: f
        });

      default:
        return null;
    }
  })));
};
var Wrapper$6 = styled("div")(function (_a) {
  var isOpenSearchMobileModal = _a.isOpenSearchMobileModal,
      overrideCss = _a.overrideCss;

  var baseCss = __assign(__assign(__assign(__assign({
    "&.csui-fil-wrapper": undefined
  }, pcSearchFilterWrapperCss), pcSearchFilterChildCss), createSpSearchFilterWrapperCss({
    isOpen: isOpenSearchMobileModal
  })), spSearchFilterChildCss);

  var additionalCss = overrideCss && overrideCss({
    isOpenSearchMobileModal: isOpenSearchMobileModal
  });
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

var SearchIcon = function SearchIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root$4, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    className: className,
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  }));
};
var Root$4 = styled("svg")(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  vertical-align: middle;\n  transform: rotate(0deg);\n  margin: auto;\n"], ["\n  vertical-align: middle;\n  transform: rotate(0deg);\n  margin: auto;\n"])));
var templateObject_1$4;

/**
 * __KeywordForm__
 * - キーワード検索フォームです
 * - component `KeywordForm` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * @param {IKeywordFormProps} props
 * @param {IKeywordFormProps["searchWithCondition"]} props.searchWithCondition - `searchWithCondition` を指定（検索ボタンクリック時に発火）
 * @param {IKeywordFormStyledProps["overrideCss"]} [props.overrideCss] - デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @example
 * import { KeywordForm, useCreativeSearch, IKeywordFormProps } from 'creative-search-ui'
 *
 * const YourComponent = () => {
 *   const { searchWithCondition } = useCreativeSearch({ baseUrl: 'Your api base url'})
 *
 *   return <KeywordForm searchWithCondition={searchWithCondition} overrideCss={yourOverrideCss} />
 * }
 */

var KeywordForm = function KeywordForm(_a) {
  var searchWithCondition = _a.searchWithCondition,
      overrideCss = _a.overrideCss;
  var t = useTranslation().t;
  var dispatch = useAdSearchPageDispatchContext().dispatch;

  var _b = useAdSearchPageStateContext(),
      isWrapped = _b.isWrapped,
      isMobile = _b.isMobile,
      query = _b.query;

  var _c = useState(""),
      searchQuery = _c[0],
      setSearchQuery = _c[1];

  if (!isWrapped) throw new Error("Provider is missing. Please wrap with CreativeSearchProvider");

  var handleClickInput = function handleClickInput(e) {
    if (!isMobile) return;
    e.currentTarget.blur();
    dispatch(adSearchPageActions.setSpSearchModal(true));
  };

  return /*#__PURE__*/React.createElement(Wrapper$5, {
    className: "csui-kf-wrapper",
    overrideCss: overrideCss
  }, !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "csui-kf-wrapper-pc"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-kf-input-wrapper-pc"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      searchWithCondition();
      dispatch(adSearchPageActions.inputQueryAction(searchQuery));
      e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "csui-kf-input-pc",
    type: "text",
    onChange: function onChange(e) {
      setSearchQuery(e.target.value);
    },
    placeholder: t("keywordForm.placeholder"),
    defaultValue: query ? query : "",
    value: searchQuery,
    autoFocus: !isMobile,
    onClick: handleClickInput
  }))), /*#__PURE__*/React.createElement("button", {
    className: "csui-kf-search-icon-pc",
    onClick: function onClick() {
      searchWithCondition();
      dispatch(adSearchPageActions.inputQueryAction(searchQuery));
    }
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    size: 20
  }))), isMobile && /*#__PURE__*/React.createElement("input", {
    className: "csui-kf-input-mobile",
    placeholder: t("keywordForm.placeholder"),
    onClick: handleClickInput
  }));
};
var Wrapper$5 = styled("div")(function (_a) {
  var _b;

  var overrideCss = _a.overrideCss;
  var baseCss = {
    "&.csui-kf-wrapper": {
      margin: "10px 0"
    },
    ".csui-kf-wrapper-pc": (_b = {
      display: "flex",
      justifyContent: "center"
    }, _b[getMediaquery("sp")] = {
      display: "none"
    }, _b),
    ".csui-kf-input-wrapper-pc": {
      borderRadius: "2px 0 0 2px",
      border: "1px solid #d3d3d3",
      borderRight: "none",
      width: "80%"
    },
    ".csui-kf-input-pc": {
      height: "28px",
      padding: "1px 6px",
      width: "100%",
      outline: "none",
      backgroundColor: "transparent",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      border: "none",
      marginLeft: "4px"
    },
    ".csui-kf-search-icon-pc": {
      padding: "1px 6px",
      backgroundColor: "#f8f8f8",
      width: "65px",
      height: "32px",
      border: "1px solid #d3d3d3",
      outline: "none",
      cursor: "pointer"
    },
    ".csui-kf-input-mobile": {
      outline: "none",
      border: "none",
      borderBottom: "gray solid 1px",
      margin: "15px 0",
      padding: "5px 0",
      width: "100%",
      backgroundColor: "transparent",
      fontSize: "16px"
    }
  };
  var additionalCss = overrideCss && overrideCss();
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

/**
 * __MobileModal__
 * - モバイルデバイス（画面幅1000px未満）で使用されるモーダルです
 * - component `MobileModal` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります
 * @param {IMobileModalProps} props
 * @param {ICreativeListItem} props.creative GH情報を追加した後のcreative情報
 * @param {Config} props.config GHプロフィールのURLのオブジェクト
 * @param {() => void} props.onClose `() => closeMobileModal()` を指定する（モーダルを閉じる時に発火）
 * @param {DisplayProperty[]} [props.displayProperties] カードに表示する項目を指定する
 * @param {(creativeListItem: ICreativeListItem) => JSX.Element} [props.cardFooterElement] - カードのフッター拡張領域を使用する場合に使用
 * @param {JSX.Element} [props.footerChild] モーダルのフッターの拡張領域に表示するコンポーネント
 * @param {IMobileModalStyledProps["overrideCss"]} [props.overrideCss] デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @example
 * import { MobileModal, useCreativeSearch, IMobileModalProps } from 'creative-search-ui';
 *
 * const YourComponent = () => {
 *   const { closeMobileModal } = useCreativeSearch({ baseUrl: 'Your api base url'})
 *
 *   return <MobileModal
 *    creative={yourCreative}
 *    config={yourConfig}
 *    onClose={() => closeMobileModal('your_current_page_path')}
 *    displayProperties={yourDisplayProperties}
 *    cardFooterElement={yourCardFooterElement}
 *    footerChild={yourFooterElement}
 *    contentRender={yourContentRenderFunc}
 *    overrideCss={yourOverrideCss}
 *   />
 * };
 */

var MobileModal = function MobileModal(props) {
  var _a, _b;

  var t = useTranslation().t;
  var adSearchPageState = useAdSearchPageStateContext();
  var targetStreamingUrl = props.creative[adSearchPageState.targetStreamingUrl];
  var loadingImageSrc = adSearchPageState.loadingImageSrc;
  var dispatch = useAdSearchPageDispatchContext().dispatch;
  if (!adSearchPageState.isWrapped) throw new Error("Provider is missing. Please wrap with CreativeSearchProvider");
  var config = props.config,
      creative = props.creative,
      footerChild = props.footerChild,
      onClose = props.onClose,
      displayProperties = props.displayProperties,
      overrideCss = props.overrideCss,
      cardFooterElement = props.cardFooterElement;
  var isImg = creative === null || creative === void 0 ? void 0 : creative.contentType.startsWith("image");
  return adSearchPageState.isMobile && adSearchPageState.selectedCard ? /*#__PURE__*/React.createElement(Wrapper$4, {
    className: "csui-mobile-mdl-wrapper",
    isOpen: adSearchPageState.isOpenSpCardMobileModal,
    overrideCss: overrideCss
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-mobile-mdl-creative-wrapper"
  }, creative ? isImg ? /*#__PURE__*/React.createElement("img", {
    className: "csui-mobile-mdl-image-screen",
    src: creative.fileUrl
  }) : targetStreamingUrl ? /*#__PURE__*/React.createElement("div", {
    className: "csui-mobile-mdl-video-screen"
  }, /*#__PURE__*/React.createElement(VideoPlayer, {
    key: (creative === null || creative === void 0 ? void 0 : creative.id) || -1,
    videoId: (_a = creative === null || creative === void 0 ? void 0 : creative.kaizenFilesId) !== null && _a !== void 0 ? _a : "",
    manifestUrl: targetStreamingUrl,
    scriptKey: "",
    onReady: function onReady() {},
    autoplay: true,
    muted: true,
    isFullWidth: true,
    isDisplayFlex: false
  })) : /*#__PURE__*/React.createElement("img", {
    className: "csui-mobile-mdl-image-screen",
    src: loadingImageSrc
  }) : /*#__PURE__*/React.createElement(Spinner, null)), /*#__PURE__*/React.createElement("div", {
    className: "csui-mobile-mdl-card-content"
  }, (displayProperties === null || displayProperties === void 0 ? void 0 : displayProperties.includes("title")) && creative.title && /*#__PURE__*/React.createElement("p", {
    className: "csui-mobile-mdl-video-title"
  }, creative.title), (displayProperties === null || displayProperties === void 0 ? void 0 : displayProperties.includes("createdDate")) && creative.createdDate && /*#__PURE__*/React.createElement("p", {
    className: "csui-mobile-mdl-video-date"
  }, creative.createdDate), (displayProperties === null || displayProperties === void 0 ? void 0 : displayProperties.includes("ghInfo")) && /*#__PURE__*/React.createElement("div", {
    className: "csui-mobile-mdl-GH-info-wrapper"
  }, (creative === null || creative === void 0 ? void 0 : creative.optimizerProfileImageUrl) ? /*#__PURE__*/React.createElement("a", {
    className: "csui-mobile-mdl-avatar-link",
    href: config.PROFILE_WEB_URL + "/users/" + creative.optimizerId,
    target: "_blank",
    rel: "noreferrer",
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "csui-mobile-mdl-avatar-img",
    src: creative.optimizerProfileImageUrl
  })) : /*#__PURE__*/React.createElement(DummyAvatarIcon, {
    className: "w-6 h-6",
    size: 20
  }), creative.ghName && /*#__PURE__*/React.createElement("p", {
    className: "csui-mobile-mdl-GH-name"
  }, creative.ghName)), (displayProperties === null || displayProperties === void 0 ? void 0 : displayProperties.includes("tag")) && /*#__PURE__*/React.createElement("div", {
    className: "csui-mobile-mdl-tag-wrapper"
  }, (_b = creative === null || creative === void 0 ? void 0 : creative.organizationTag) === null || _b === void 0 ? void 0 : _b.map(function (tag) {
    return /*#__PURE__*/React.createElement("span", {
      className: "csui-mobile-mdl-tag-span",
      key: tag
    }, tag);
  }), /*#__PURE__*/React.createElement(MoreIcon, {
    className: "w-6 h-6",
    size: 20
  })), (displayProperties === null || displayProperties === void 0 ? void 0 : displayProperties.includes("contentFooter")) && !!cardFooterElement && /*#__PURE__*/React.createElement("div", {
    className: "csui-mobile-mdl-card-footer"
  }, cardFooterElement(creative))), /*#__PURE__*/React.createElement("div", {
    className: "csui-mobile-mdl-close-button",
    onClick: function onClick() {
      onClose();
      dispatch(adSearchPageActions.setSpCardModal(false));
      dispatch(adSearchPageActions.selectCardAction(null));
    }
  }, /*#__PURE__*/React.createElement("span", null, t("playModal.close"))), (displayProperties === null || displayProperties === void 0 ? void 0 : displayProperties.includes("footerChild")) && !!footerChild && /*#__PURE__*/React.createElement("div", {
    className: "csui-mobile-mdl-footer-wrapper"
  }, footerChild)) : null;
};
var Wrapper$4 = styled("div")(function (_a) {
  var isOpen = _a.isOpen,
      overrideCss = _a.overrideCss;
  var baseCss = {
    "&.csui-mobile-mdl-wrapper": {
      position: "fixed",
      width: "100vw",
      maxHeight: "100vh",
      height: "100%",
      backgroundColor: "white",
      top: "0",
      left: "0",
      zIndex: "3",
      padding: "12px",
      paddingTop: "62px",
      transition: "all 0.3s ease-in-out 0s",
      transform: isOpen ? "translateY(0%)" : "translateY(-100%)",
      display: "flex",
      flexDirection: "column",
      overflow: "auto"
    },
    ".csui-mobile-mdl-creative-wrapper": {
      height: "auto",
      textAlign: "center",
      backgroundColor: "black",
      position: "relative",
      width: "100%"
    },
    ".csui-mobile-mdl-video-screen": {
      objectFit: "cover",
      width: "100%",
      height: "100%",
      padding: "0"
    },
    ".csui-mobile-mdl-image-screen": {
      objectFit: "contain",
      width: "100%",
      height: "100%",
      padding: "0"
    },
    ".csui-mobile-mdl-card-content": {
      padding: "0 4px",
      display: "flex",
      flexDirection: "column"
    },
    ".csui-mobile-mdl-video-title": {
      fontSize: "16px",
      margin: "10px 0",
      display: "block",
      overflowWrap: "anywhere"
    },
    ".csui-mobile-mdl-video-date": {
      color: "gray",
      fontSize: "10px"
    },
    ".csui-mobile-mdl-GH-info-wrapper": {
      display: "flex",
      margin: "10px 0"
    },
    ".csui-mobile-mdl-tag-wrapper": {
      display: "flex",
      flexWrap: "wrap"
    },
    ".csui-mobile-mdl-avatar-link": {
      margin: "auto 0"
    },
    ".csui-mobile-mdl-avatar-img": {
      width: "20px",
      borderRadius: "50%",
      margin: "0 auto"
    },
    ".csui-mobile-mdl-GH-name": {
      paddingLeft: "10px",
      fontWeight: "bold",
      fontSize: "12px",
      display: "inline-block",
      margin: "auto 0"
    },
    ".csui-mobile-mdl-tag-span": {
      borderRadius: "5px",
      backgroundColor: "#99dc92",
      display: "inline-block",
      padding: "4px 10px",
      marginRight: "5px",
      whiteSpace: "nowrap",
      marginTop: "5px"
    },
    ".csui-mobile-mdl-card-footer": {
      width: "100%",
      margin: "10px 0"
    },
    ".csui-mobile-mdl-footer-wrapper": {
      display: "flex",
      justifyContent: "space-between",
      paddingTop: "20px"
    },
    ".csui-mobile-mdl-close-button": {
      display: "flex",
      justifyContent: "center",
      position: "relative",
      margin: "10px auto",
      textAlign: "center",
      verticalAlign: "middle",
      backgroundColor: "#04a46f",
      width: "150px",
      borderRadius: "4px",
      color: "#fff",
      lineHeight: "32px",
      WebkitTransition: "none",
      transition: "none",
      boxShadow: "0 3px 0 #0e8c73",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)",
      "&:hover": {
        backgroundColor: "#31c8aa",
        boxShadow: "0 3px 0 #23a188"
      },
      "&:active": {
        top: "3px",
        boxShadow: "none"
      }
    }
  };
  var additionalCss = overrideCss && overrideCss({
    isOpen: isOpen
  });
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

/**
 * __ImageViewer__
 * component `Modal` で静止画を表示するイメージビュアーコンポーネントです。
 * @param {IImageViewerProps["clickable"]} props.clickable - イメージビュアーをクリックした時、遷移可能かどうかを指定する場合に使用
 * @param {IImageViewerProps["scalable"]} props.scalable - イメージビュアーにカーソルがホバーした時のアニメーションの有無を指定する場合に使用
 * @param {IImageViewerProps["content"]} props.content - イメージビュアーに表示するcreative情報
 * @param {IImageViewerStyledProps["overrideCss"]} [props.overrideCss] - デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用

 *
 * import { ImageViewer, Modal } from 'creative-search-ui'
 *
 * const YourComponent = () => {
 *
 *   return (
 *    <Modal
 *      contentRender={(content) => {
 *       if (content.data.contentType.startsWith('image')) {
 *        return <ImageViewer content={content} />;
 *       }
 *       // other type viewer component
 *      />
 *  )
 * }
 */

var ImageViewer = function ImageViewer(_a) {
  var content = _a.content,
      _b = _a.clickable,
      clickable = _b === void 0 ? false : _b,
      _c = _a.scalable,
      scalable = _c === void 0 ? false : _c,
      overrideCss = _a.overrideCss;
  return /*#__PURE__*/React.createElement(Wrapper$3, {
    className: "csui-i-view-wrapper",
    isContentTypeMixed: content.isContentTypeMixed,
    overrideCss: overrideCss
  }, /*#__PURE__*/React.createElement("div", {
    className: content.isContentTypeMixed ? "csui-i-view-img-with-video-media-wrapper" : "csui-i-view-img-media-wrapper"
  }, clickable ? /*#__PURE__*/React.createElement("a", {
    className: "csui-i-view-anchor-link",
    href: content.data.fileUrl,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    className: "csui-cl-card-pc-img-screen-img",
    src: content.data.fileUrl
  })) : /*#__PURE__*/React.createElement("img", {
    className: scalable ? "csui-cl-card-pc-img-screen-scalable-img" : "csui-cl-card-pc-img-screen-img",
    src: content.data.fileUrl
  })));
};
var Wrapper$3 = styled("div")(function (_a) {
  var isContentTypeMixed = _a.isContentTypeMixed,
      overrideCss = _a.overrideCss;
  var baseCss = {
    "&.csui-i-view-wrapper": undefined,
    ".csui-i-view-img-media-wrapper": {
      height: "700px",
      width: "1000px",
      justifyContent: "center",
      backgroundColor: "black"
    },
    ".csui-i-view-img-with-video-media-wrapper": {
      minWidth: "270px",
      maxWidth: "360px",
      height: "460px",
      justifyContent: "center",
      backgroundColor: "black"
    },
    ".csui-cl-card-pc-img-screen-anchor-link": {
      display: "flex",
      alignItems: "center"
    },
    ".csui-cl-card-pc-img-screen-img": {
      background: "#000",
      width: "100%",
      height: "100%",
      objectFit: isContentTypeMixed ? "contain" : undefined
    },
    ".csui-cl-card-pc-img-screen-scalable-img": {
      background: "#000",
      width: "100%",
      height: "100%",
      cursor: "pointer",
      transition: "transform 0.2s ease-out",
      "&:hover": {
        transform: "scale(1.5)"
      }
    }
  };
  var additionalCss = overrideCss && overrideCss({
    isContentTypeMixed: isContentTypeMixed
  });
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

/**
 * __VideoViewer__
 * component `Modal` で動画を表示するビデオビュアーコンポーネントです。
 * @param {IVideoViewerProps["content"]} props.content - ビデオビュアーに表示するcreative情報
 * @param {IVideoViewerProps["muted"]} props.muted - 動画に含まれる音声の設定
 * @param {IVideoViewerProps["autoPlay"]} props.autoPlay - 動画が再生可能な状態になった時点で即座にコンテンツを再生する設定
 * @param {IVideoViewerProps["controls"]} props.controls - 再生、音量、シーク、ポーズの各機能を制御するコントロールを表示する設定
 * @param {IVideoViewerStyledProps["overrideCss"]} [props.overrideCss] - デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用

 *
 * import { VideoViewer, Modal } from 'creative-search-ui'
 *
 * const YourComponent = () => {
 *
 *   return (
 *    <Modal
 *      contentRender={(content) => {
 *       if (content.data.contentType.startsWith('video')) {
 *        return <VideoViewer content={content} />;
 *       }
 *       // other type viewer component
 *      />
 *  )
 * }
 */

var VideoViewer = function VideoViewer(_a) {
  var _b;

  var content = _a.content,
      _c = _a.muted,
      muted = _c === void 0 ? true : _c;
      _a.autoPlay;
      var _d = _a.controls,
      controls = _d === void 0 ? true : _d,
      overrideCss = _a.overrideCss;
  var videoRef = useRef(null);
  var state = useAdSearchPageStateContext();
  var creative = content.data;
  var isPlay = state.isPlayAllVideos;
  var targetStreamingUrl = creative[state.targetStreamingUrl];
  var loadingImageSrc = state.loadingImageSrc;
  useEffect(function () {
    if (isPlay) {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      }
    }
  }, [isPlay]);
  return /*#__PURE__*/React.createElement(Wrapper$2, {
    className: "csui-v-viewer-wrapper",
    overrideCss: overrideCss
  }, targetStreamingUrl ? /*#__PURE__*/React.createElement("div", {
    className: "csui-v-viewer-video"
  }, /*#__PURE__*/React.createElement(VideoPlayer, {
    key: (creative === null || creative === void 0 ? void 0 : creative.id) || -1,
    videoId: (_b = creative === null || creative === void 0 ? void 0 : creative.kaizenFilesId) !== null && _b !== void 0 ? _b : "",
    manifestUrl: targetStreamingUrl,
    scriptKey: "",
    onReady: function onReady() {},
    autoplay: isPlay,
    muted: muted,
    plyrOptions: controls ? {} : {
      controls: []
    },
    isPlay: isPlay,
    isFullWidth: false,
    isDisplayFlex: true
  })) : /*#__PURE__*/React.createElement("img", {
    className: "csui-v-viewer-loading-image",
    src: loadingImageSrc
  }));
};
var Wrapper$2 = styled("div")(function (_a) {
  var overrideCss = _a.overrideCss;
  var baseCss = {
    "&.csui-v-viewer-wrapper": {
      minWidth: "270px",
      maxWidth: "360px",
      height: "460px",
      justifyContent: "center",
      backgroundColor: "black"
    },
    ".csui-v-viewer-video": {
      backgroundColor: "#000",
      objectFit: "contain",
      width: "100%",
      height: "460px"
    },
    ".csui-v-viewer-loading-image": {
      background: "#000",
      width: "100%",
      height: "100%",
      objectFit: "contain"
    }
  };
  var additionalCss = overrideCss && overrideCss();
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

var CloseIcon = function CloseIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root$3, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    className: className,
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M6 18L18 6M6 6l12 12"
  }));
};
var Root$3 = styled("svg")(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  color: gray;\n  cursor: pointer;\n  cursor: hand;\n"], ["\n  color: gray;\n  cursor: pointer;\n  cursor: hand;\n"])));
var templateObject_1$3;

var allDisplayProperties$1 = ["title", "createdDate", "ghInfo", "contentFooter"];
var defaultDisplayProperties$1 = __spreadArray([], allDisplayProperties$1);
var ModalMediaModalPlayer = function ModalMediaModalPlayer(props) {
  var state = useAdSearchPageStateContext();
  var selectedCard = state.selectedCard ? [state.selectedCard] : state.checkedCards.length > 0 ? state.checkedCards : [];
  var imageData = selectedCard.filter(function (creative) {
    return creative.contentType.startsWith("image");
  });
  var videoData = selectedCard.filter(function (creative) {
    return creative.contentType.startsWith("video");
  });
  var isContentTypeMixed = imageData.length > 0 && videoData.length > 0;
  var data = props.data,
      _a = props.displayProperties,
      displayProperties = _a === void 0 ? __spreadArray([], defaultDisplayProperties$1) : _a,
      contentRender = props.contentRender,
      cardFooterElement = props.cardFooterElement;
  var MAX_LENGTH = 15;
  var DataVideoTitle = data.title ? data.title : "";

  if (DataVideoTitle.length > MAX_LENGTH) {
    DataVideoTitle.substr(0, MAX_LENGTH) + "...";
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-player-wrapper"
  }, contentRender({
    data: data,
    isContentTypeMixed: isContentTypeMixed
  }), /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-player-video-info-wrapper"
  }, displayProperties.includes("title") && data.title && /*#__PURE__*/React.createElement("span", {
    className: "csui-mdl-media-player-video-title"
  }, data.title), displayProperties.includes("createdDate") && data.createdDate && /*#__PURE__*/React.createElement("p", {
    className: "csui-mdl-media-player-video-time"
  }, data.createdDate)), displayProperties.includes("ghInfo") && /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-player-gh-wrapper"
  }, data.optimizerProfileImageUrl ? /*#__PURE__*/React.createElement("img", {
    className: "csui-mdl-media-player-gh-img",
    src: data.optimizerProfileImageUrl
  }) : /*#__PURE__*/React.createElement(DummyAvatarIcon, {
    className: "w-6 h-6",
    size: 30
  }), data.ghName && /*#__PURE__*/React.createElement("p", {
    className: "csui-mdl-media-player-gh-name"
  }, data.ghName)), displayProperties.includes("contentFooter") && !!cardFooterElement && /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-player-video-footer"
  }, cardFooterElement(data)));
};
var modalMediaModalPlayerCss = {
  "csui-mdl-media-player-wrapper": {
    margin: "auto 0",
    flexshrink: "0",
    "@media (max-width: 480px)": {
      width: "100%"
    },
    "&:not(:last-child)": {
      marginRight: "10px !important"
    }
  },
  ".csui-mdl-media-player-video-info-wrapper": {
    display: "flex",
    flexFlow: "column"
  },
  ".csui-mdl-media-player-video-title": {
    fontSize: "16px",
    margin: "10px 0",
    minWidth: "270px",
    maxWidth: "360px",
    display: "block",
    overflowWrap: "anywhere"
  },
  ".csui-mdl-media-player-video-time": {
    color: "gray",
    fontSize: "12px !important",
    margin: "5px 0",
    marginBottom: "10px",
    display: "inline-block"
  },
  ".csui-mdl-media-player-gh-wrapper": {
    display: "flex"
  },
  ".csui-mdl-media-player-gh-icon-link": {
    margin: "auto 0"
  },
  ".csui-mdl-media-player-gh-name": {
    paddingLeft: "10px",
    fontWeight: "bold",
    margin: "auto 0"
  },
  ".csui-mdl-media-player-gh-img": {
    width: "30px",
    borderRadius: "50%",
    margin: "0 auto"
  },
  ".csui-mdl-media-player-video-footer": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginTop: "8px",
    padding: "8px",
    marginTop: "10px"
  }
};

var CENTERING_THRESHOLD = 3;

var allDisplayProperties = __spreadArray(__spreadArray([], allDisplayProperties$1), ["modalFooter"]);

var defaultDisplayProperties = __spreadArray([], allDisplayProperties);

var filterDisplayPropertyForPlayer = function filterDisplayPropertyForPlayer(displayProperties) {
  if (!Array.isArray(displayProperties)) return undefined;
  return displayProperties.filter(function (p) {
    return __spreadArray([], allDisplayProperties$1).includes(p);
  });
};

var MediaModal = function MediaModal(props) {
  var modalTitle = props.modalTitle,
      creatives = props.creatives,
      _a = props.displayProperties,
      displayProperties = _a === void 0 ? __spreadArray([], defaultDisplayProperties) : _a,
      cardFooterElement = props.cardFooterElement,
      modalFooter = props.modalFooter,
      contentRender = props.contentRender,
      onClose = props.onClose;
  var t = useTranslation().t;
  var state = useAdSearchPageStateContext();
  var dispatch = useAdSearchPageDispatchContext().dispatch;
  var data = state.selectedCard ? [state.selectedCard] : state.checkedCards.length > 0 ? state.checkedCards : [];
  var isPlay = state.isPlayAllVideos;
  /**
   * モーダルを閉じる時の処理
   */

  var handleCloseModal = function handleCloseModal() {
    dispatch(adSearchPageActions.selectCardAction(null));
    dispatch(adSearchPageActions.setModalTypeAction(null));
    dispatch(adSearchPageActions.setPlayAllVideos(false));
    onClose();
  };

  var handleClickPlayButton = function handleClickPlayButton() {
    dispatch(adSearchPageActions.setPlayAllVideos(!isPlay));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-modal-header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "csui-mdl-media-modal-title"
  }, modalTitle), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return handleCloseModal();
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: "w-6 h-6",
    size: 24
  }))), data ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-players"
  }, creatives.map(function (creative) {
    return /*#__PURE__*/React.createElement(ModalMediaModalPlayer, {
      key: creative.id,
      data: creative,
      displayProperties: filterDisplayPropertyForPlayer(displayProperties),
      cardFooterElement: cardFooterElement,
      contentRender: contentRender
    });
  })), /*#__PURE__*/React.createElement("a", {
    className: "csui-mdl-media-play-button",
    onClick: handleClickPlayButton
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-play-icon-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-play-icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "csui-mdl-media-play-button-text"
  }, t("playModal.playAll"))), displayProperties.includes("modalFooter") && !!modalFooter && /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-media-modal-footer"
  }, modalFooter)) : /*#__PURE__*/React.createElement(Spinner, null));
};
var createModalMediaModalCss = function createModalMediaModalCss(dataLength) {
  return {
    ".csui-mdl-media-wrapper": {
      display: "flex",
      flexDirection: "column"
    },
    ".csui-mdl-media-modal-header": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      margin: "15px"
    },
    ".csui-mdl-media-modal-title": {
      margin: "auto 0"
    },
    ".csui-mdl-media-players": {
      display: "flex",
      overflowX: "auto",
      width: "100%",
      justifyContent: dataLength <= CENTERING_THRESHOLD ? "center" : "space-between",
      "@media (max-width: 480px)": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }
    },
    ".csui-mdl-media-play-button": {
      cursor: "pointer",
      // cursor: 'hand',
      display: "flex",
      justifyContent: "center",
      position: "relative",
      margin: "15px auto",
      textAlign: "center",
      verticalAlign: "middle",
      backgroundColor: "#04a46f",
      width: "150px",
      borderRadius: "4px",
      color: "#fff",
      lineHeight: "52px",
      WebkitTransition: "none",
      transition: "none",
      boxShadow: "0 3px 0 #0e8c73",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)",
      "&:hover": {
        backgroundColor: "#31c8aa",
        boxShadow: "0 3px 0 #23a188"
      },
      "&:active": {
        top: "3px",
        boxShadow: "none"
      }
    },
    ".csui-mdl-media-play-icon-wrapper": {
      height: "100%",
      margin: "auto 10px"
    },
    ".csui-mdl-media-play-icon": {
      verticalAlign: "center",
      height: "100%",
      borderTop: "8px solid transparent",
      borderLeft: "10.66px solid white",
      borderBottom: "8px solid transparent"
    },
    ".csui-mdl-media-play-button-text": {
      color: "white"
    },
    ".csui-mdl-media-modal-footer": {
      width: "100%",
      justifyContent: "space-around",
      display: "flex"
    }
  };
};

var MinusCircleIcon = function MinusCircleIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root$2, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    className: className,
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
};
var Root$2 = styled("svg")(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  color: white;\n  cursor: pointer;\n  cursor: hand;\n"], ["\n  color: white;\n  cursor: pointer;\n  cursor: hand;\n"])));
var templateObject_1$2;

var PlusCircleIcon = function PlusCircleIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root$1, {
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z",
    clipRule: "evenodd"
  }));
};
var Root$1 = styled("svg")(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  margin: auto;\n  display: block;\n"], ["\n  margin: auto;\n  display: block;\n"])));
var templateObject_1$1;

var TagEditModal = function TagEditModal(props) {
  var _a;

  var t = useTranslation().t;
  var AdSearchPageState = useAdSearchPageStateContext();
  var AdSearchState = useAdSearchStateContext();
  var AdSearchPageDispatch = useAdSearchPageDispatchContext().dispatch;
  var AdSearchDispatch = useAdSearchDispatchContext().dispatch;
  var tagInputRef = useRef(null);

  var _b = useState(false),
      canAddTag = _b[0],
      setCanAddTag = _b[1];
  /**
   * モーダルを閉じる時の処理
   */


  var handleCloseModal = function handleCloseModal() {
    AdSearchPageDispatch(adSearchPageActions.selectCardAction(null));
    AdSearchPageDispatch(adSearchPageActions.setModalTypeAction(null));
  };

  var handleTagInputChanged = function handleTagInputChanged(e) {
    // 入力されたタグ名を取得します
    var tagName = e.target.value; // 入力された名前のタグが既に関連付けられている場合は、「追加」ボタンをクリックできないようにします

    var contain = false;

    if (AdSearchPageState.selectedCard != null) {
      AdSearchPageState.selectedCard.organizationTag.map(function (s) {
        if (tagName.trim() === s) {
          contain = true;
        }
      });
    }

    if (contain) {
      setCanAddTag(false);
      return;
    } // 入力が空文字でなければ「追加」ボタンをクリックできるように変更します


    setCanAddTag(tagName.trim() !== "");
  };

  var handleAddTag = function handleAddTag() {
    if (!AdSearchPageState.selectedCard) {
      throw new Error("please choice card.");
    }

    props.onClickTagAdd(AdSearchPageState.selectedCard, AdSearchPageState.tagInput, props.organizationId);
    if (!AdSearchState.adSearch.data) return;
    var newCreatives = AdSearchState.adSearch.data.creatives.map(function (creative) {
      var _a;

      if (creative.id === ((_a = AdSearchPageState.selectedCard) === null || _a === void 0 ? void 0 : _a.id)) {
        return __assign(__assign({}, creative), {
          organizationTag: __spreadArray([AdSearchPageState.tagInput], AdSearchPageState.selectedCard.organizationTag)
        });
      }

      return creative;
    });
    AdSearchDispatch(adSearchActions.updateCreatives(newCreatives));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-tag-edit-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-tag-edit-tag-modal-header"
  }, /*#__PURE__*/React.createElement("p", {
    className: "csui-mdl-tag-edit-video-title"
  }, props.title), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return handleCloseModal();
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: "w-6 h-6",
    size: 24
  }))), /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-tag-edit-tag-modal-body"
  }, (_a = AdSearchPageState.selectedCard) === null || _a === void 0 ? void 0 : _a.organizationTag.map(function (tag) {
    return /*#__PURE__*/React.createElement("span", {
      key: tag,
      className: "csui-mdl-tag-edit-tag-span"
    }, /*#__PURE__*/React.createElement("p", {
      className: "csui-mdl-tag-edit-tag-p",
      onClick: function onClick() {
        if (!AdSearchPageState.selectedCard) {
          throw new Error("please choice card.");
        }

        props.onClickTagDelete(AdSearchPageState.selectedCard, tag, props.organizationId);
        if (!AdSearchState.adSearch.data) return;
        var newCreatives = AdSearchState.adSearch.data.creatives.map(function (creative) {
          var _a;

          if (creative.id === ((_a = AdSearchPageState.selectedCard) === null || _a === void 0 ? void 0 : _a.id)) {
            return __assign(__assign({}, creative), {
              organizationTag: AdSearchPageState.selectedCard.organizationTag.filter(function (t) {
                return t !== tag;
              })
            });
          }

          return creative;
        });
        AdSearchDispatch(adSearchActions.updateCreatives(newCreatives));
      }
    }, /*#__PURE__*/React.createElement(MinusCircleIcon, {
      className: "w-6 h-6",
      size: 24
    })), tag);
  })), /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-tag-edit-input-area-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-tag-edit-input-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    className: "csui-mdl-tag-edit-tag-input",
    type: "text",
    placeholder: t("tag.add"),
    ref: tagInputRef,
    onBlur: function onBlur(e) {
      AdSearchPageDispatch(adSearchPageActions.inputNewTagAction(e.target.value));

      if (tagInputRef && tagInputRef.current) {
        tagInputRef.current.value = "";
      }
    },
    onChange: handleTagInputChanged
  })), /*#__PURE__*/React.createElement("button", {
    className: "csui-mdl-tag-edit-tag-add-button",
    disabled: !canAddTag,
    onClick: function onClick() {
      handleAddTag();
    }
  }, /*#__PURE__*/React.createElement(PlusCircleIcon, {
    size: 24
  }))));
};
var modalTagEditModalCss = {
  ".csui-mdl-tag-edit-wrapper": undefined,
  ".csui-mdl-tag-edit-tag-modal-header": {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px"
  },
  ".csui-mdl-tag-edit-tag-modal-body": {
    width: "100%",
    padding: "10px"
  },
  ".csui-mdl-tag-edit-tag-span": {
    borderRadius: "5px",
    backgroundColor: "#99dc92",
    display: "inline-block",
    padding: "4px 10px",
    marginRight: "20px",
    margin: "5px"
  },
  ".csui-mdl-tag-edit-tag-p": {
    marginRight: "3px",
    display: "inline-block",
    verticalAlign: "middle"
  },
  ".csui-mdl-tag-edit-input-area-wrapper": {
    display: "flex",
    justifyContent: "center",
    margin: "18px auto"
  },
  ".csui-mdl-tag-edit-input-wrapper": {
    borderRadius: "2px 0 0 2px",
    border: "1px solid #d3d3d3",
    borderRight: "none",
    width: "60%"
  },
  ".csui-mdl-tag-edit-tag-input": {
    height: "34px",
    padding: "1px 6px",
    width: "100%",
    outline: "none",
    backgroundColor: "transparent",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    border: "none",
    marginLeft: "4px"
  },
  ".csui-mdl-tag-edit-tag-add-button": {
    padding: "4px 9px",
    backgroundColor: "f8f8f8",
    width: "65px",
    height: "38px",
    border: "1px solid #d3d3d3",
    outline: "none",
    cursor: "pointer" // cursor: "hand",

  },
  ".csui-mdl-tag-edit-video-title": {
    fontWeight: "bold"
  }
};

/**
 * __Modal__
 * - PCデバイス（画面幅1000px以上）で使用されるモーダルです
 * - component `Modal` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります
 * @param {IModalProps} props
 * @param {ICreativeListItem[]} props.creatives - GH情報を追加した後のcreativesの配列
 * @param {IMediaModalProps["modalTitle"]} props.title モーダルのタイトル
 * @param {IMediaModalProps["onClose"]} props.onClose モーダル閉じる関数
 * @param {IMediaModalProps["displayProperties"]} [props.displayProperties] カードに表示する項目を指定する配列
 * @param {IMediaModalProps["cardFooterElement"]} [props.cardFooterElement] - カードのフッター拡張領域を使用する場合に使用
 * @param {IMediaModalProps["modalFooter"]} [props.footer] モーダルフッター拡張領域で使用するElement
 * @param {IMediaModalProps["contentRender"]} [props.contentRender] 外部から独自のviewerを注入するためのレンダープロップ
 * @param {ITagEditModalProps["onClickTagAdd"]} props.onClickTagAdd `onClickTagAdd` を指定する（タグ編集モーダルのタグ追加関数）
 * @param {ITagEditModalProps["onClickTagDelete"]} props.onClickTagDelete `onClickTagDelete` を指定する（タグ編集モーダルのタグ削除関数）
 * @param {ITagEditModalProps["organizationId"]} props.organizationId `organizationId` を指定する（フロントエンドでユーザーが現在ログインしている組織ID）
 * @param {IModalProps["overrideCss"]} [props.overrideCss]
 * @param {IModalStyledProps["overrideCss"]} [props.overrideCss.modal] モーダルについて、デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @param {IImageViewerProps["overrideCss"]} [props.overrideCss.imageViewer] イメージビュアー要素について、デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @param {IVideoViewerProps["overrideCss"]} [props.overrideCss.videoViewer] ビデオビュアー要素について、デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @example
 *  import { Modal, useCreativeSearch, IModalProps } from 'creative-search-ui';
 *
 * const YourComponent = () => {
 *   const { onClickTagAdd, onClickTagDelete } = useCreativeSearch({ baseUrl: 'Your api base url'})
 *
 *   return <Modal
 *    creatives={yourCreatives}
 *    title={yourTitle}
 *    onClose={yourOnCloseFunc}
 *    displayProperties={yourDisplayProperties}
 *    cardFooterElement={yourCardFooterElement}
 *    footer={yourFooterElement}
 *    contentRender={yourContentRenderFunc}
 *    onClickTagAdd={onClickTagAdd}
 *    onClickTagDelete={onClickTagDelete}
 *    overrideCss={yourOverrideCss}
 *   />
 * };
 */

var Modal = function Modal(_a) {
  var creatives = _a.creatives,
      title = _a.title,
      contentRender = _a.contentRender,
      displayProperties = _a.displayProperties,
      footer = _a.footer,
      cardFooterElement = _a.cardFooterElement,
      onClickTagAdd = _a.onClickTagAdd,
      onClickTagDelete = _a.onClickTagDelete,
      onClose = _a.onClose,
      overrideCss = _a.overrideCss,
      organizationId = _a.organizationId;
  var t = useTranslation().t;

  var defaultContentRender = function defaultContentRender(viewerProps) {
    var data = viewerProps.data;
    var fileType = ExtensionDeterminator.whichImageOrMovieFromContentType(data.contentType);
    if (!fileType) throw new Error("FileType is null");

    switch (fileType) {
      case "movie":
        return /*#__PURE__*/React.createElement(VideoViewer, {
          content: viewerProps,
          overrideCss: overrideCss === null || overrideCss === void 0 ? void 0 : overrideCss.videoViewer
        });

      case "image":
        return /*#__PURE__*/React.createElement(ImageViewer, {
          content: viewerProps,
          overrideCss: overrideCss === null || overrideCss === void 0 ? void 0 : overrideCss.imageViewer
        });

      default:
        return /*#__PURE__*/React.createElement("div", null, "error");
    }
  };

  var state = useAdSearchPageStateContext();
  if (!state.isWrapped) throw new Error("Provider is missing. Please wrap with CreativeSearchProvider");
  var data = state.selectedCard ? [state.selectedCard] : state.checkedCards.length > 0 ? state.checkedCards : [];
  if (!state.modalContensType) return null;
  return /*#__PURE__*/React.createElement(Wrapper$1, {
    className: "csui-mdl-wrapper",
    dataLength: data.length,
    overrideCss: overrideCss === null || overrideCss === void 0 ? void 0 : overrideCss.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-mdl-content"
  }, state.modalContensType === "preview" ? /*#__PURE__*/React.createElement(MediaModal, {
    onClose: onClose,
    modalTitle: title,
    creatives: creatives,
    displayProperties: displayProperties,
    cardFooterElement: cardFooterElement,
    modalFooter: footer,
    contentRender: contentRender || defaultContentRender
  }) : state.modalContensType === "tagEdit" && state.selectedCard ? /*#__PURE__*/React.createElement(TagEditModal, {
    onClickTagAdd: onClickTagAdd,
    onClickTagDelete: onClickTagDelete,
    title: t("tag.modalTitle"),
    organizationId: organizationId
  }) : /*#__PURE__*/React.createElement("p", null, "error"))));
};
var Wrapper$1 = styled("div")(function (_a) {
  var dataLength = _a.dataLength,
      overrideCss = _a.overrideCss;

  var baseCss = __assign(__assign(__assign({
    "&.csui-mdl-wrapper": {
      borderRadius: "5px",
      position: "fixed",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      zIndex: "20",
      padding: "0 30px"
    },
    ".csui-mdl-overlay": {
      width: "80%",
      background: "#fff",
      borderRadius: "3px",
      padding: "1em",
      maxWidth: "1080px"
    },
    ".csui-mdl-content": {
      width: "100%"
    }
  }, createModalMediaModalCss(dataLength)), modalMediaModalPlayerCss), modalTagEditModalCss);

  var additionalCss = overrideCss && overrideCss({
    dataLength: dataLength
  });
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

var PlayIcon = function PlayIcon(_a) {
  var size = _a.size,
      className = _a.className;
  return /*#__PURE__*/React.createElement(Root, {
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
};
var Root = styled("svg")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  vertical-align: middle;\n  display: block;\n  height: 100%;\n"], ["\n  vertical-align: middle;\n  display: block;\n  height: 100%;\n"])));
var templateObject_1;

/**
 * __SelectController__
 * - 一覧の中で選択された creatives に対する操作を行うエリアです
 * - component `SelectController` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * @param {ISelectControllerProps} props
 * @param {Creative[]} props.creatives `checkedCards` を指定（選択された creatives ）
 * @param {ISelectControllerStyledProps["overrideCss"]} [props.overrideCss] デフォルトのCSSよりも優先度の高いCSSを指定する場合に使用
 * @example
 * import { SelectController, useCreativeSearch, ISelectControllerProps } from 'creative-search-ui';
 *
 * const YourComponent = () => {
 *   const { checkedCards } = useCreativeSearch({ baseUrl: 'Your api base url'})
 *
 *   return <SelectController creatives={checkedCards} overrideCss={yourOverrideCss} >
 * };
 */

var SelectController = function SelectController(_a) {
  var creatives = _a.creatives,
      overrideCss = _a.overrideCss;
  var dispatch = useAdSearchPageDispatchContext().dispatch;
  var t = useTranslation().t;
  var state = useAdSearchPageStateContext();
  var currentOrganizationId = state.currentOrganizationId;
  if (!state.isWrapped) throw new Error("Provider is missing. Please wrap with CreativeSearchProvider");

  var handleClickCloseButton = function handleClickCloseButton() {
    dispatch(adSearchPageActions.selectCardsAction([]));
  };

  var handlePlayCardsButton = function handlePlayCardsButton() {
    creatives.length > 0 && dispatch(adSearchPageActions.setModalTypeAction("preview"));
    window.history.pushState("", "", "?org=" + currentOrganizationId + "&ids=" + creatives.map(function (c) {
      return c.id;
    }).join(","));
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: "csui-sc-wrapper",
    creatives: creatives,
    overrideCss: overrideCss
  }, /*#__PURE__*/React.createElement("div", {
    className: "csui-sc-uncheck-button",
    onClick: function onClick() {
      return handleClickCloseButton();
    }
  }, t("selectController.uncheck")), /*#__PURE__*/React.createElement("div", {
    className: "csui-sc-play-button",
    onClick: function onClick() {
      return handlePlayCardsButton();
    }
  }, /*#__PURE__*/React.createElement(PlayIcon, {
    size: 24
  })));
};
var Wrapper = styled("div")(function (_a) {
  var _b;

  var creatives = _a.creatives,
      overrideCss = _a.overrideCss;
  var baseCss = {
    "&.csui-sc-wrapper": (_b = {
      margin: "10px 0",
      display: "flex"
    }, _b[getMediaquery("sp")] = {
      display: "none"
    }, _b),
    ".csui-sc-uncheck-button": {
      borderRadius: "5px",
      backgroundColor: "#e2e8f0",
      padding: "5px 10px",
      // cursor: "pointer",
      // cursor: "hand",
      width: "140px",
      display: creatives.length === 0 ? "none" : "initial",
      cursor: creatives.length === 0 ? "default" : "pointer",
      textAlign: "center",
      lineHeight: "initial"
    },
    ".csui-sc-play-button": {
      borderRadius: "5px",
      padding: "5px 10px",
      marginLeft: "10px",
      // cursor: "pointer",
      // cursor: 'hand',
      cursor: creatives.length === 0 ? "default" : "pointer",
      color: creatives.length === 0 ? "#c0c0c0" : "white",
      backgroundColor: creatives.length === 0 ? "#dcdcdc" : "#00a46e"
    }
  };
  var additionalCss = overrideCss && overrideCss({
    creatives: creatives
  });
  if (_typeof(additionalCss) !== "object") return css(__assign({}, baseCss));
  return [css(__assign({}, baseCss)), css(__assign({}, additionalCss))];
});

var Bucket =
/** @class */
function () {
  function Bucket(_a) {
    var value = _a.value,
        count = _a.count;
    this.value = value;
    this.count = count;
  }

  Bucket.fromJSON = function (bucket) {
    var _a = Object.assign({}, bucket),
        value = _a.value,
        count = _a.count;

    if (value == null || typeof value !== "string") {
      throw new Error(".Bucket.value must be a string");
    }

    if (count == null || typeof count !== "number") {
      throw new Error(".Bucket.count must be a number");
    }

    return new Bucket({
      value: value,
      count: count
    });
  };

  return Bucket;
}();

var OrganizationTag =
/** @class */
function () {
  function OrganizationTag(_a) {
    var buckets = _a.buckets;
    this.buckets = buckets;
  }

  OrganizationTag.fromJSON = function (json) {
    var buckets = Object.assign({}, json).buckets;

    try {
      var _buckets = buckets.map(function (bucket) {
        return Bucket.fromJSON(bucket);
      });

      return new OrganizationTag({
        buckets: _buckets
      });
    } catch (_a) {
      throw new Error(".facets.tag must be a { buckets: { value: string; count: number }[]}");
    }
  };

  return OrganizationTag;
}();

var CreativeIndexForDirectorWeb =
/** @class */
function () {
  function CreativeIndexForDirectorWeb(_a) {
    var count = _a.count,
        creatives = _a.creatives,
        facets = _a.facets;
    this.count = count;
    this.creatives = creatives;
    this.facets = facets;
  }

  CreativeIndexForDirectorWeb.fromJSON = function (json) {
    var _a = Object.assign({}, json),
        count = _a.count,
        creatives = _a.creatives,
        facets = _a.facets;

    if (typeof count !== "number") {
      throw new Error(".count must be a number");
    }

    return new CreativeIndexForDirectorWeb({
      count: count,
      creatives: creatives,
      facets: facets
    });
  };

  return CreativeIndexForDirectorWeb;
}();

var SCOPE_LIST = [1, 2, 3];
/**
 * Creative Entity.
 *
 * @desc constructorをprivateにしているため、fromJSONからのみinstance化が可能。
 *
 * @example <caption>fromJSONからinstance化</caption>
 * Creative.fromJSON({...})
 *
 * @example <caption>new からはできない。</caption>
 * new Creative({...}) // instance化できない
 */

var Creative =
/** @class */
function () {
  function Creative(_a) {
    var id = _a.id,
        favorite = _a.favorite,
        fileUrl = _a.fileUrl,
        originalHlsUrl = _a.originalHlsUrl,
        previewWartermarkMp4Url = _a.previewWartermarkMp4Url,
        logoWatermarkHlsUrl = _a.logoWatermarkHlsUrl,
        height = _a.height,
        industry = _a.industry,
        thumbnailUrl = _a.thumbnailUrl,
        width = _a.width,
        contentType = _a.contentType,
        fileSize = _a.fileSize,
        fileUpdatedAt = _a.fileUpdatedAt,
        organizationTag = _a.organizationTag,
        optimizerId = _a.optimizerId,
        organizationId = _a.organizationId,
        scope = _a.scope,
        service = _a.service,
        tag = _a.tag,
        placement = _a.placement,
        aspectRatio = _a.aspectRatio,
        duration = _a.duration,
        composition = _a.composition,
        optimizerProfileImageUrl = _a.optimizerProfileImageUrl,
        salesIsPublished = _a.salesIsPublished,
        salesProductContentId = _a.salesProductContentId,
        salesCreatedAt = _a.salesCreatedAt,
        kaizenFilesId = _a.kaizenFilesId;
    this.id = id;
    this.favorite = favorite;
    this.contentType = contentType;
    this.fileSize = fileSize;
    this.organizationId = organizationId;
    this.optimizerId = optimizerId;
    this.fileUrl = fileUrl;
    this.originalHlsUrl = originalHlsUrl;
    this.previewWartermarkMp4Url = previewWartermarkMp4Url;
    this.logoWatermarkHlsUrl = logoWatermarkHlsUrl;
    this.fileUpdatedAt = fileUpdatedAt;
    this.width = width;
    this.height = height;
    this.thumbnailUrl = thumbnailUrl;
    this.tag = tag;
    this.industry = industry;
    this.service = service;
    this.scope = scope;
    this.placement = placement;
    this.aspectRatio = aspectRatio;
    this.duration = duration;
    this.composition = composition;
    this.optimizerProfileImageUrl = optimizerProfileImageUrl;
    this.organizationTag = organizationTag;
    this.salesIsPublished = salesIsPublished;
    this.salesProductContentId = salesProductContentId;
    this.salesCreatedAt = salesCreatedAt;
    this.kaizenFilesId = kaizenFilesId;
  }

  Creative.fromJSON = function (json) {
    var _a = Object.assign({}, json),
        id = _a.id,
        favorite = _a.favorite,
        contentType = _a.contentType,
        fileSize = _a.fileSize,
        organizationId = _a.organizationId,
        optimizerId = _a.optimizerId,
        fileUrl = _a.fileUrl,
        originalHlsUrl = _a.originalHlsUrl,
        previewWartermarkMp4Url = _a.previewWartermarkMp4Url,
        logoWatermarkHlsUrl = _a.logoWatermarkHlsUrl,
        fileUpdatedAt = _a.fileUpdatedAt,
        width = _a.width,
        height = _a.height,
        thumbnailUrl = _a.thumbnailUrl,
        tag = _a.tag,
        industry = _a.industry,
        service = _a.service,
        scope = _a.scope,
        placement = _a.placement,
        aspectRatio = _a.aspectRatio,
        duration = _a.duration,
        composition = _a.composition,
        optimizerProfileImageUrl = _a.optimizerProfileImageUrl,
        organizationTag = _a.organizationTag,
        salesIsPublished = _a.salesIsPublished,
        salesProductContentId = _a.salesProductContentId,
        salesCreatedAt = _a.salesCreatedAt,
        kaizenFilesId = _a.kaizenFilesId;

    if (typeof id !== "string") {
      throw new Error(".id must be a string");
    }

    if (typeof favorite !== "number") {
      throw new Error(".favorite must be a 0 or 1");
    }

    if (typeof contentType !== "string") {
      throw new Error(".contentType must be a string");
    }

    if (typeof fileSize !== "number") {
      throw new Error(".fileSize must be a number");
    }

    if (typeof organizationId !== "number") {
      throw new Error(".organizationId must be a number");
    }

    if ((optimizerId || optimizerId !== null) && typeof optimizerId !== "number") {
      throw new Error(".optimizerId must be a number or null");
    }

    if (fileUrl && typeof fileUrl !== "string") {
      throw new Error(".fileUrl must be a string");
    }

    if ((originalHlsUrl || originalHlsUrl !== null) && typeof originalHlsUrl !== "string") {
      throw new Error(".originalHlsUrl must be a string or null");
    }

    if ((previewWartermarkMp4Url || previewWartermarkMp4Url !== null) && typeof previewWartermarkMp4Url !== "string") {
      throw new Error(".previewWartermarkMp4Url must be a string or null");
    }

    if ((logoWatermarkHlsUrl || logoWatermarkHlsUrl !== null) && typeof logoWatermarkHlsUrl !== "string") {
      throw new Error(".logoWatermarkHlsUrl must be a string or null");
    }

    var _fileUpdatedAt = dayjs(fileUpdatedAt);

    if ((width || width !== null) && typeof width !== "number") {
      throw new Error(".width must be a number or null");
    }

    if ((height || height !== null) && typeof height !== "number") {
      throw new Error(".height must be a number or null");
    }

    if ((thumbnailUrl || thumbnailUrl !== null) && typeof thumbnailUrl !== "string") {
      throw new Error(".thumbnailUrl must be a string");
    }

    if (tag && !Array.isArray(tag)) {
      throw new Error(".tag must be a Array");
    }

    if ((industry || industry !== null) && !Array.isArray(industry)) {
      throw new Error(".industry must be a Array");
    }

    if (organizationTag && !Array.isArray(organizationTag)) {
      throw new Error(".organizationTag must be a Array");
    }

    if (!["ad", "sales"].includes(service)) {
      throw new Error('.service must be a "ad" or "sales"');
    }

    if (scope && !SCOPE_LIST.includes(scope)) {
      throw new Error(".scope must be a 1 or 2 or 3");
    }

    if ((salesIsPublished || salesIsPublished !== null) && typeof salesIsPublished !== "number") {
      throw new Error(".salesIsPublished must be a number or null");
    }

    if ((salesProductContentId || salesProductContentId !== null) && typeof salesProductContentId !== "number") {
      throw new Error(".salesProductContentId must be a number or null");
    }

    if ((salesCreatedAt || salesCreatedAt !== null) && typeof salesCreatedAt !== "string") {
      throw new Error(".salesCreatedAt must be a string or null");
    }

    if ((kaizenFilesId || kaizenFilesId !== null) && typeof kaizenFilesId !== "string") {
      throw new Error(".kaizenFilesId must be a string or null");
    }

    return new Creative({
      id: id,
      favorite: favorite,
      fileUrl: fileUrl,
      originalHlsUrl: originalHlsUrl,
      previewWartermarkMp4Url: previewWartermarkMp4Url,
      logoWatermarkHlsUrl: logoWatermarkHlsUrl,
      height: height,
      industry: industry,
      thumbnailUrl: thumbnailUrl,
      width: width,
      contentType: contentType,
      fileSize: fileSize,
      fileUpdatedAt: _fileUpdatedAt,
      optimizerId: optimizerId,
      organizationId: organizationId,
      scope: scope,
      service: service,
      tag: tag,
      placement: placement,
      aspectRatio: aspectRatio,
      duration: duration,
      composition: composition,
      optimizerProfileImageUrl: optimizerProfileImageUrl,
      organizationTag: organizationTag,
      salesIsPublished: salesIsPublished,
      salesProductContentId: salesProductContentId,
      salesCreatedAt: salesCreatedAt,
      kaizenFilesId: kaizenFilesId
    });
  };

  return Creative;
}();

var ApiError =
/** @class */
function (_super) {
  __extends(ApiError, _super);

  function ApiError(responseStatus, responseBody, message) {
    var _this = _super.call(this, message || JSON.stringify({
      responseStatus: responseStatus,
      responseBody: responseBody
    })) || this;

    _this.isApiError = true;
    _this.responseStatus = responseStatus;
    _this.responseBody = responseBody;
    return _this;
  }

  return ApiError;
}(Error);
var AdSearchWebApi = function AdSearchWebApi(baseURL) {
  var baseUrlFStr = baseURL.toJSON();
  var fetchHeader = {
    Accept: "application/json, text/plain, */*"
  };

  var getCreatives = function getCreatives(request, oid) {
    return __awaiter(void 0, void 0, void 0, function () {
      var url, removeUndefinedFromObject, params, query, response, status_1, body, entity, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            url = baseUrlFStr + "api/creatives?";
            if (oid) Object.assign(request, {
              currentOrganizationId: oid
            });

            removeUndefinedFromObject = function removeUndefinedFromObject(object) {
              return Object.assign(Object.entries(object).filter(function (_a) {
                _a[0];
                    var v = _a[1];
                return v !== undefined;
              }));
            };

            params = removeUndefinedFromObject(request);
            query = new URLSearchParams(params).toString();
            return [4
            /*yield*/
            , fetch(url + query, {
              method: "GET",
              credentials: "include",
              headers: fetchHeader
            })];

          case 1:
            response = _a.sent();
            status_1 = response.status;
            return [4
            /*yield*/
            , response.json()];

          case 2:
            body = _a.sent();
            if (status_1 !== 200) throw new ApiError(status_1, body);
            entity = {
              count: body.count,
              // FIXME: I/Fの型がどうしてもあわないのでany. entityの中で型のチェックやバリデーションを行うので戻り値は信頼できると言う前提にたっている.
              creatives: body.creatives.map(function (creative) {
                return creative;
              }),
              facets: body.allFacets
            };
            return [2
            /*return*/
            , entity];

          case 3:
            err_1 = _a.sent();
            throw new ApiError(err_1.responseStatus, err_1.responseBody, err_1.message);

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 指定IDのcreativeを取得する
   */


  var getCreativesByIds = function getCreativesByIds(cardIds) {
    return __awaiter(void 0, void 0, void 0, function () {
      var param, response, status_2, body, entity, err_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            param = "api/creatives/find?ids=" + cardIds.join(",");
            return [4
            /*yield*/
            , fetch(baseUrlFStr + param, {
              method: "GET",
              credentials: "include",
              headers: fetchHeader
            })];

          case 1:
            response = _a.sent();
            status_2 = response.status;
            return [4
            /*yield*/
            , response.json()];

          case 2:
            body = _a.sent();
            if (status_2 !== 200) throw new ApiError(status_2, body);
            entity = body.creatives.map(function (creative) {
              return Creative.fromJSON(creative);
            });
            return [2
            /*return*/
            , entity];

          case 3:
            err_2 = _a.sent();
            throw new ApiError(err_2.responseStatus, err_2.responseBody, err_2.message);

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 組織に紐づくtagの追加をする
   *
   * @description oraganization_tagはログインユーザーに紐づく組織からしか見えない領域のタグ. 他社事例検索時に情報漏洩を防ぐ目的でtagと別に使われている。
   * @params cid Creative ID
   * @params name tagの名前
   * @params oid 組織id
   */


  var addTagToCreative = function addTagToCreative(cid, name, oid) {
    return __awaiter(void 0, void 0, void 0, function () {
      var param, formData, resp, status_3, body, err_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            param = "api/creatives/" + cid + "/organization_tags";
            formData = new FormData();
            formData.append("name", name);
            formData.append("creative_id", cid);

            if (oid) {
              formData.append("organization_id", oid);
            }

            return [4
            /*yield*/
            , fetch(baseUrlFStr + param, {
              method: "POST",
              body: formData,
              credentials: "include",
              headers: fetchHeader
            })];

          case 1:
            resp = _a.sent();
            status_3 = resp.status;
            return [4
            /*yield*/
            , resp.json()];

          case 2:
            body = _a.sent();
            if (status_3 !== 200) throw new ApiError(status_3, body);
            return [2
            /*return*/
            , resp];

          case 3:
            err_3 = _a.sent();
            throw new ApiError(err_3.responseStatus, err_3.responseBody, err_3.message);

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 組織に紐づくtagの削除をする
   *
   * @description oraganization_tagはログインユーザーに紐づく組織からしか見えない領域のタグ. 他社事例検索時に情報漏洩を防ぐ目的でtagと別に使われている。
   * @params cid Creative ID
   * @params name tagの名前
   * @params oid 組織id
   */


  var deleteTagfromCreative = function deleteTagfromCreative(cid, name, oid) {
    return __awaiter(void 0, void 0, void 0, function () {
      var param, formData, resp, status_4, body, err_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            param = "api/creatives/" + cid + "/organization_tags";
            formData = new FormData();
            formData.append("name", name);
            formData.append("creative_id", cid);

            if (oid) {
              formData.append("organization_id", oid);
            }

            return [4
            /*yield*/
            , fetch(baseUrlFStr + param, {
              method: "DELETE",
              body: formData,
              credentials: "include",
              headers: fetchHeader
            })];

          case 1:
            resp = _a.sent();
            status_4 = resp.status;
            return [4
            /*yield*/
            , resp.json()];

          case 2:
            body = _a.sent();
            if (status_4 !== 200) throw new ApiError(status_4, body);
            return [2
            /*return*/
            , resp];

          case 3:
            err_4 = _a.sent();
            throw new ApiError(err_4.responseStatus, err_4.responseBody, err_4.message);

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * creativeに対してFavをする
   */


  var creativeFav = function creativeFav(cid) {
    return __awaiter(void 0, void 0, void 0, function () {
      var resp, status_5, body, err_5;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            return [4
            /*yield*/
            , fetch(baseUrlFStr + ("api/creatives/" + cid + "/favorites"), {
              method: "POST",
              credentials: "include",
              headers: fetchHeader
            })];

          case 1:
            resp = _a.sent();
            status_5 = resp.status;
            return [4
            /*yield*/
            , resp.json()];

          case 2:
            body = _a.sent();
            if (status_5 !== 200) throw new ApiError(status_5, body);
            return [2
            /*return*/
            , resp];

          case 3:
            err_5 = _a.sent();
            throw new ApiError(err_5.responseStatus, err_5.responseBody, err_5.message);

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * creativeのFavを解除する
   */


  var creativeUnfav = function creativeUnfav(cid) {
    return __awaiter(void 0, void 0, void 0, function () {
      var resp, status_6, body, err_6;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            return [4
            /*yield*/
            , fetch(baseUrlFStr + ("api/creatives/" + cid + "/favorites"), {
              method: "DELETE",
              credentials: "include",
              headers: fetchHeader
            })];

          case 1:
            resp = _a.sent();
            status_6 = resp.status;
            return [4
            /*yield*/
            , resp.json()];

          case 2:
            body = _a.sent();
            if (status_6 !== 200) throw new ApiError(status_6, body);
            return [2
            /*return*/
            , resp];

          case 3:
            err_6 = _a.sent();
            throw new ApiError(err_6.responseStatus, err_6.responseBody, err_6.message);

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return {
    creativeUnfav: creativeUnfav,
    creativeFav: creativeFav,
    deleteTagfromCreative: deleteTagfromCreative,
    addTagToCreative: addTagToCreative,
    getCreativesByIds: getCreativesByIds,
    getCreatives: getCreatives
  };
};

/**
 * UIが持っているrequest情報で、APIが求めるrequestオブジェクトに変換する.
 * - 配列は文字列の','結合に変換する
 * - valueがnullなものは, (key, value)共にAPIリクエストに含めない
 * - selectedOrganizations というkey名は organizationId になる.
 */

var toApiRequest = function toApiRequest(uiRequest) {
  var query = uiRequest.query,
      duration = uiRequest.duration,
      aspectRatio = uiRequest.aspectRatio,
      industry = uiRequest.industry,
      placement = uiRequest.placement,
      offset = uiRequest.offset,
      limit = uiRequest.limit,
      selectedOrganizations = uiRequest.selectedOrganizations,
      organizationTag = uiRequest.organizationTag,
      contentTypes = uiRequest.contentTypes,
      businessRegion = uiRequest.businessRegion,
      scope = uiRequest.scope,
      service = uiRequest.service,
      isOriginal = uiRequest.isOriginal,
      isPublishedAtSales = uiRequest.isPublishedAtSales,
      isCreatedAtSales = uiRequest.isCreatedAtSales;
  var creativeRequestSrc = {
    query: query,
    duration: duration,
    aspectRatio: aspectRatio,
    industry: industry,
    placement: placement,
    offset: offset,
    limit: limit,
    organizationId: selectedOrganizations.join(","),
    organizationTag: Array.isArray(organizationTag) ? organizationTag.join(",") : JSON.stringify(organizationTag),
    scope: scope.join(","),
    contentType: contentTypes.join(","),
    businessRegion: businessRegion.join(","),
    isOriginal: isOriginal === undefined ? undefined : isOriginal !== undefined && isOriginal ? 1 : 0,
    service: service.join(","),
    isPublishedAtSales: isPublishedAtSales.join(","),
    isCreatedAtSales: isCreatedAtSales ? isCreatedAtSales.toString() : ""
  };
  return Object.entries(creativeRequestSrc).reduce(function (acc, _a) {
    var _b;

    var k = _a[0],
        v = _a[1];
    if ([undefined, null, ""].includes(v)) return acc;
    return __assign(__assign({}, acc), (_b = {}, _b[k] = v, _b));
  }, {});
};

var useAdSearch = function useAdSearch(baseURL, organizationId) {
  var useCallback = React.useCallback;
  var state = useAdSearchStateContext();
  var dispatch = useAdSearchDispatchContext().dispatch;
  var adSearchPagedispatch = useAdSearchPageDispatchContext().dispatch;
  var setFetchCreativeListState = adSearchActions.setFetchCreativeListState,
      setFetchSelectedCreativeState = adSearchActions.setFetchSelectedCreativeState,
      setPostOrganizationTagState = adSearchActions.setPostOrganizationTagState,
      setDeleteOrganizationTagState = adSearchActions.setDeleteOrganizationTagState,
      setPostFavoriteState = adSearchActions.setPostFavoriteState,
      setDeleteFavoriteState = adSearchActions.setDeleteFavoriteState;
  var history = getAccessingDevice() === "sp" ? History.createBrowserHistory({
    getUserConfirmation: function getUserConfirmation(dialogKey, callback) {
      var dialogTrigger = window[dialogKey];

      if (dialogTrigger) {
        return dialogTrigger(callback);
      }

      callback(true);
    }
  }) : History.createBrowserHistory();
  var adSearchWebApi = AdSearchWebApi(baseURL);
  /**
   *
   * 選択したクリエイティブページへ遷移する関数
   * @param card 選択されたCretiveデータ.
   */

  var showDetail = function showDetail(card) {
    adSearchPagedispatch({
      type: "SELECT_CARD",
      payload: card
    });
  };
  /**
   * ビデオを取得する処理。処理に成功したらstoreにデータをセットする。失敗したらエラートーストを表示させる。
   */


  var getAdVideo = function getAdVideo(request, setFacets) {
    if (setFacets === void 0) {
      setFacets = false;
    }

    return __awaiter(void 0, void 0, void 0, function () {
      var req, data, apiFacets, facets, sortedData, err_1;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            dispatch({
              type: "SET_ADSEARCH_ACTION",
              payload: {
                isLoading: true,
                isLoaded: false,
                error: null
              }
            });
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            req = toApiRequest(request);
            return [4
            /*yield*/
            , adSearchWebApi.getCreatives(req, organizationId)];

          case 2:
            data = _b.sent();
            apiFacets = {
              industry: {
                buckets: data.facets.industry.buckets
              },
              placement: {
                buckets: data.facets.placement.buckets.sort(sortFunc)
              },
              aspectRatio: {
                buckets: data.facets.aspectRatio.buckets
              },
              composition: {
                buckets: data.facets.composition.buckets
              },
              organizationTag: {
                buckets: data.facets.organizationTag.buckets
              }
            };
            facets = setFacets ? apiFacets : (_a = state.adSearch.data) === null || _a === void 0 ? void 0 : _a.facets;
            sortedData = facets ? __assign(__assign({}, data), {
              facets: facets
            }) : data; // 取得したデータをstoreにsetする(loader止める)

            dispatch({
              type: "SET_ADSEARCH_ACTION",
              payload: {
                isLoading: false,
                isLoaded: true,
                data: sortedData,
                error: null
              }
            });
            dispatch(setFetchCreativeListState.error(undefined));
            return [3
            /*break*/
            , 4];

          case 3:
            err_1 = _b.sent();
            console.error(err_1);
            dispatch({
              type: "SET_ADSEARCH_ACTION",
              payload: {
                isLoading: false,
                isLoaded: true,
                error: err_1
              }
            });
            if (err_1.isApiError) dispatch(setFetchCreativeListState.error(err_1));
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var getMoreAdVideo = function getMoreAdVideo(request) {
    return __awaiter(void 0, void 0, void 0, function () {
      var req, data, sortedData, existedData, addedData, err_2;

      var _a, _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            dispatch({
              type: "SET_ADSEARCH_ACTION",
              payload: {
                isLoading: true,
                isLoaded: false,
                error: null
              }
            });
            _c.label = 1;

          case 1:
            _c.trys.push([1, 3,, 4]);

            req = toApiRequest(request);
            return [4
            /*yield*/
            , adSearchWebApi.getCreatives(req, organizationId)];

          case 2:
            data = _c.sent();
            sortedData = __assign(__assign({}, data), {
              facets: {
                industry: {
                  buckets: data.facets.industry.buckets
                },
                placement: {
                  buckets: data.facets.placement.buckets.sort(sortFunc)
                },
                aspectRatio: {
                  buckets: data.facets.aspectRatio.buckets
                },
                composition: {
                  buckets: (_a = data.facets.composition) === null || _a === void 0 ? void 0 : _a.buckets
                },
                organizationTag: {
                  buckets: (_b = data.facets.composition) === null || _b === void 0 ? void 0 : _b.buckets
                }
              }
            });
            existedData = state.adSearch.data;
            addedData = void 0;

            if (existedData) {
              addedData = CreativeIndexForDirectorWeb.fromJSON({
                count: existedData.count,
                facets: existedData.facets,
                creatives: __spreadArray(__spreadArray([], existedData.creatives), sortedData.creatives)
              });
            } else {
              // 初回ロードしていないので、取ってきたデータを初回データとして保管する
              addedData = CreativeIndexForDirectorWeb.fromJSON(data);
            } // 取得したデータをstoreにsetする(loader止める)


            dispatch({
              type: "SET_ADSEARCH_ACTION",
              payload: {
                isLoading: false,
                isLoaded: true,
                data: addedData,
                error: null
              }
            });
            dispatch(setFetchCreativeListState.error(undefined));
            return [3
            /*break*/
            , 4];

          case 3:
            err_2 = _c.sent();
            console.error(err_2);
            dispatch({
              type: "SET_ADSEARCH_ACTION",
              payload: {
                isLoading: false,
                isLoaded: true,
                error: err_2
              }
            });
            if (err_2.isApiError) dispatch(setFetchCreativeListState.error(err_2));
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 指定されたidのcreativeを取得して、選択中クリエイティブとしてstoreに保存する.
   */


  var setSelectedCardDataByIds = function setSelectedCardDataByIds(cardIds) {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, err_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , adSearchWebApi.getCreativesByIds(cardIds)];

          case 1:
            data = _a.sent();
            dispatch(setFetchSelectedCreativeState.error(undefined));
            return [2
            /*return*/
            , data];

          case 2:
            err_3 = _a.sent();
            console.error(err_3);
            dispatch({
              type: "SET_ADSEARCH_ACTION",
              payload: {
                isLoading: false,
                isLoaded: true,
                error: err_3
              }
            });
            if (err_3.isApiError) dispatch(setFetchSelectedCreativeState.error(err_3));
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * searchへ戻る
   */


  var closeMobileModal = function closeMobileModal(location) {
    history.push(location);
  };
  /**
   * tagを追加する. 追加時、サーバーに処理させる前にUIを反映させる。
   * @param cid creative id
   * @param name tagの名前
   */


  var addTagToCreative = function addTagToCreative(creative, name, organizationId) {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, creatives, i, targetCreative, addedTagCreative, addedOrganizationTags, addedData, err_4;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            data = state.adSearch.data;
            if (!data) throw new Error("unsetted data");
            creatives = [];

            for (i = 0; i < data.creatives.length; i++) {
              targetCreative = data.creatives[i];

              if (targetCreative.id === creative.id) {
                addedTagCreative = __assign(__assign({}, targetCreative), {
                  organizationTag: __spreadArray([name], targetCreative.organizationTag)
                });
                creatives.push(addedTagCreative);
              } else {
                creatives.push(targetCreative);
              }
            }

            addedOrganizationTags = data.facets.organizationTag.buckets.map(function (bucket) {
              return bucket.value;
            }).includes(name) ? (_a = data.facets.organizationTag) === null || _a === void 0 ? void 0 : _a.buckets : __spreadArray(__spreadArray([], data.facets.organizationTag.buckets), [Bucket.fromJSON({
              value: name,
              count: 1
            })]);
            addedData = CreativeIndexForDirectorWeb.fromJSON(__assign(__assign({}, data), {
              facets: __assign(__assign({}, data.facets), {
                organizationTag: OrganizationTag.fromJSON({
                  buckets: addedOrganizationTags
                })
              }),
              creatives: creatives
            }));
            dispatch({
              type: "SET_CREATIVE_INDEX_FOR_DIRECTOR_WEB_ACTION",
              payload: addedData
            });
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , adSearchWebApi.addTagToCreative(creative.id, name, organizationId)];

          case 2:
            _b.sent();

            dispatch(setPostOrganizationTagState.error(undefined));
            return [3
            /*break*/
            , 4];

          case 3:
            err_4 = _b.sent();
            console.error(err_4);
            if (err_4.isApiError) dispatch(setPostOrganizationTagState.error(err_4));
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * tagを削除する. 削除時、サーバーに処理させる前にUIを反映させる。
   * @param cid creative id
   * @param name tagの名前
   */


  var deleteTagToCreative = function deleteTagToCreative(creative, name, organizationId) {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, creatives, i, targetCreative, deleted, filteredOrganizationTags, filteredData, err_5;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            data = state.adSearch.data;
            if (!data) throw new Error("unsetted data");
            creatives = [];

            for (i = 0; i < data.creatives.length; i++) {
              targetCreative = data.creatives[i];

              if (targetCreative.id === creative.id) {
                deleted = __assign(__assign({}, targetCreative), {
                  organizationTag: targetCreative.organizationTag.filter(function (t) {
                    return t !== name;
                  })
                });
                creatives.push(deleted);
              } else {
                creatives.push(targetCreative);
              }
            }

            filteredOrganizationTags = (_a = data.facets.organizationTag) === null || _a === void 0 ? void 0 : _a.buckets.filter(function (bucket) {
              return bucket.value !== name || bucket.count > 1;
            }).map(function (bucket) {
              return bucket.value === name ? Bucket.fromJSON(__assign(__assign({}, bucket), {
                count: bucket.count - 1
              })) : bucket;
            });
            filteredData = CreativeIndexForDirectorWeb.fromJSON(__assign(__assign({}, data), {
              facets: __assign(__assign({}, data.facets), {
                organizationTag: OrganizationTag.fromJSON({
                  buckets: filteredOrganizationTags
                })
              }),
              creatives: creatives
            }));
            dispatch({
              type: "SET_CREATIVE_INDEX_FOR_DIRECTOR_WEB_ACTION",
              payload: filteredData
            });
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , adSearchWebApi.deleteTagfromCreative(creative.id, name, organizationId)];

          case 2:
            _b.sent();

            dispatch(setDeleteOrganizationTagState.error(undefined));
            return [3
            /*break*/
            , 4];

          case 3:
            err_5 = _b.sent();
            console.error(err_5);
            if (err_5.isApiError) dispatch(setDeleteOrganizationTagState.error(err_5));
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * ファボもしくはファボ解除する。
   */


  var setFavUnfav = function setFavUnfav(cid, shouldFavorite) {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, creatives, i, targetCreative, toggledCreative, filteredData, err_6, err_7;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            data = state.adSearch.data;
            if (!data) throw new Error("unsetted data");
            creatives = [];

            for (i = 0; i < data.creatives.length; i++) {
              targetCreative = data.creatives[i];

              if (targetCreative.id === cid) {
                toggledCreative = __assign(__assign({}, targetCreative), {
                  favorite: shouldFavorite
                });
                creatives.push(toggledCreative);
              } else {
                creatives.push(targetCreative);
              }
            }

            filteredData = __assign(__assign({}, data), {
              creatives: creatives
            });
            dispatch({
              type: "SET_CREATIVE_INDEX_FOR_DIRECTOR_WEB_ACTION",
              payload: filteredData
            });
            if (!shouldFavorite) return [3
            /*break*/
            , 5];
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , adSearchWebApi.creativeFav(cid)];

          case 2:
            _a.sent();

            dispatch(setPostFavoriteState.error(undefined));
            return [3
            /*break*/
            , 4];

          case 3:
            err_6 = _a.sent();
            console.error(err_6);
            if (err_6.isApiError) dispatch(setPostFavoriteState.error(err_6));
            return [3
            /*break*/
            , 4];

          case 4:
            return [3
            /*break*/
            , 8];

          case 5:
            _a.trys.push([5, 7,, 8]);

            return [4
            /*yield*/
            , adSearchWebApi.creativeUnfav(cid)];

          case 6:
            _a.sent();

            dispatch(setDeleteFavoriteState.error(undefined));
            return [3
            /*break*/
            , 8];

          case 7:
            err_7 = _a.sent();
            console.error(err_7);
            if (err_7.isApiError) dispatch(setDeleteFavoriteState.error(err_7));
            return [3
            /*break*/
            , 8];

          case 8:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var adSearch = state.adSearch,
      fetchCreativeListState = state.fetchCreativeListState,
      fetchSelectedCreativesState = state.fetchSelectedCreativesState,
      postOrganizationTagState = state.postOrganizationTagState,
      deleteOrganizationTagState = state.deleteOrganizationTagState,
      postFavoriteState = state.postFavoriteState,
      deleteFavoriteState = state.deleteFavoriteState;
  var apiErrors = {
    fetchCreativeList: fetchCreativeListState.error,
    fetchSelectedCreatives: fetchSelectedCreativesState.error,
    postOrganizationTag: postOrganizationTagState.error,
    deleteOrganizationTag: deleteOrganizationTagState.error,
    postFavorite: postFavoriteState.error,
    deleteFavorite: deleteFavoriteState.error
  };
  var resetApiErrors = {
    fetchCreativeList: useCallback(function () {
      return dispatch(setFetchCreativeListState.error(undefined));
    }, []),
    fetchSelectedCreatives: useCallback(function () {
      return dispatch(setFetchSelectedCreativeState.error(undefined));
    }, []),
    postOrganizationTag: useCallback(function () {
      return dispatch(setPostOrganizationTagState.error(undefined));
    }, []),
    deleteOrganizationTag: useCallback(function () {
      return dispatch(setDeleteOrganizationTagState.error(undefined));
    }, []),
    postFavorite: useCallback(function () {
      return dispatch(setPostFavoriteState.error(undefined));
    }, []),
    deleteFavorite: useCallback(function () {
      return dispatch(setDeleteFavoriteState.error(undefined));
    }, [])
  };
  return __assign(__assign({}, adSearch), {
    addTagToCreative: addTagToCreative,
    deleteTagToCreative: deleteTagToCreative,
    setFavUnfav: setFavUnfav,
    showDetail: showDetail,
    getAdVideo: getAdVideo,
    getMoreAdVideo: getMoreAdVideo,
    setSelectedCardDataByIds: setSelectedCardDataByIds,
    closeMobileModal: closeMobileModal,
    apiErrors: apiErrors,
    resetApiErrors: resetApiErrors
  });
};

function noop() {}

function camelToHyphen(camelString) {
  return camelString.replace(/[A-Z]/g, function (string) {
    return "-" + string.toLowerCase();
  }).toLowerCase();
}

var QUERY_COMBINATOR = " and ";

function queryObjectToString(query) {
  if (typeof query === "string") {
    return query;
  }

  return Object.entries(query).map(function (_a) {
    var feature = _a[0],
        value = _a[1];
    var convertedFeature = camelToHyphen(feature);
    var convertedValue = value;

    if (typeof convertedValue === "boolean") {
      return convertedValue ? convertedFeature : "not " + convertedFeature;
    }

    if (typeof convertedValue === "number" && /[height|width]$/.test(convertedFeature)) {
      convertedValue = convertedValue + "px";
    }

    return "(" + convertedFeature + ": " + convertedValue + ")";
  }).join(QUERY_COMBINATOR);
}

var mockMediaQueryList = {
  media: "",
  matches: false,
  onchange: noop,
  addListener: noop,
  removeListener: noop,
  addEventListener: noop,
  removeEventListener: noop,
  dispatchEvent: function dispatchEvent(_) {
    return true;
  }
};

var createUseMedia = function createUseMedia(effect) {
  return function (rawQuery, defaultState) {
    if (defaultState === void 0) {
      defaultState = false;
    }

    var query = queryObjectToString(rawQuery);
    defaultState = window.matchMedia(query).matches;

    var _a = useState(defaultState),
        state = _a[0],
        setState = _a[1];

    effect(function () {
      var mounted = true;
      var mediaQueryList = typeof window === "undefined" ? mockMediaQueryList : window.matchMedia(query);

      var onChange = function onChange() {
        if (!mounted) {
          return;
        }

        setState(Boolean(mediaQueryList.matches));
      };

      mediaQueryList.addListener(onChange);
      setState(mediaQueryList.matches);
      return function () {
        mounted = false;
        mediaQueryList.removeListener(onChange);
      };
    }, [query]);
    return state;
  };
};

var useMedia = createUseMedia(useEffect);

function on(obj) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  if (obj && obj.addEventListener) {
    obj.addEventListener.apply(obj, args);
  }
}
function off(obj) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  if (obj && obj.removeEventListener) {
    obj.removeEventListener.apply(obj, args);
  }
}
var isBrowser = typeof window !== "undefined";

var getValue = function getValue(search, param) {
  return new URLSearchParams(search).get(param);
};

var useSearchParam = function useSearchParam(param) {
  var location = window.location;

  var _a = useState(function () {
    return getValue(location.search, param);
  }),
      value = _a[0],
      setValue = _a[1];

  useEffect(function () {
    var onChange = function onChange() {
      setValue(getValue(location.search, param));
    };

    on(window, "popstate", onChange);
    on(window, "pushstate", onChange);
    on(window, "replacestate", onChange);
    return function () {
      off(window, "popstate", onChange);
      off(window, "pushstate", onChange);
      off(window, "replacestate", onChange);
    };
  }, []);
  return value;
};

var useSearchParamServer = function useSearchParamServer() {
  return null;
};

var useSearchParam$1 = isBrowser ? useSearchParam : useSearchParamServer;

var OFFSET_WIDTH = 20;
/**
 * __useCreativeSearch__
 * creative検索を行うHooks
 * hooks `useCreativeSearch` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * ラップせずに hooks `useCreativeSearch` を呼び出した場合、エラーが発生します。
 * 内部で `useContext` を利用しているため、コンポーネント `CreativeSearchProvider` でラップした子コンポーネント、孫コンポーネントでもコンテキストを利用できます。
 * @param baseUrl エンドポイントのベースURL
 * @param staticQuery creative検索の初期条件を指定
 * @param breakpointForMobile モバイルのブレイクポイントを指定
 * @param organizationId 現在ログイン中の組織ID
 * @param targetStreamingUrl ストリーミング再生させるURLのプロパティ名を指定
 * @param loadingImageSrc ストリーミング用URLが返却されなかった場合(＝ストリーミングファイルがまだ生成できていない場合)にサムネイル表示する画像
 * @example
 * const {
 *   selectedCardForModal,
 *   handleClickCard,
 *   ...
 * } = useCreativeSearch({
 *  baseUrl: 'https://someUrl.com',
 *  staticQuery: { scope: [1, 2], contentTypes: ['video/*'], service: ['ad'] ... }
 *  organizationId: '1494'
 *  targetStreamingUrl: 'originalHlsUrl'
 *  loadingImageSrc: '/sample.mpeg'
 * });
 */

var useCreativeSearch = function useCreativeSearch(_a) {
  var baseUrl = _a.baseUrl,
      staticQuery = _a.staticQuery,
      _b = _a.breakpointForMobile,
      breakpointForMobile = _b === void 0 ? 1000 : _b,
      organizationId = _a.organizationId,
      targetStreamingUrl = _a.targetStreamingUrl,
      loadingImageSrc = _a.loadingImageSrc;
  var state = useAdSearchPageStateContext();
  if (!state.isWrapped) throw new Error("Please Wrap AdSearchPage with CreativeSearchProvider");
  var dispatch = useAdSearchPageDispatchContext().dispatch;
  var LocaleDispatch = useLocaleDispatchContext().dispatch;

  var _c = useAdSearch(baseUrl, organizationId),
      isLoading = _c.isLoading,
      data = _c.data,
      addTagToCreative = _c.addTagToCreative,
      deleteTagToCreative = _c.deleteTagToCreative,
      setFavUnfav = _c.setFavUnfav,
      showDetail = _c.showDetail,
      getAdVideo = _c.getAdVideo,
      getMoreAdVideo = _c.getMoreAdVideo,
      setSelectedCardDataByIds = _c.setSelectedCardDataByIds,
      closeMobileModal = _c.closeMobileModal,
      apiErrors = _c.apiErrors,
      resetApiErrors = _c.resetApiErrors;

  var selectedCardForModal = state.selectedCard ? [state.selectedCard] : state.checkedCards.length > 0 ? state.checkedCards : [];
  var searchQueryCacheState = useSearchQueryStateContext();
  var didMountRef = useRef(false);
  var isPC = useMedia({
    minWidth: breakpointForMobile + "px"
  });
  useEffect(function () {
    dispatch(adSearchPageActions.setIsMobile(!isPC));
  }, [isPC]);
  var idsStr = useSearchParam$1("ids");
  /**
   * 検索条件が変更されるたびに自動で検索をする。
   * そのため検索条件を監視し、変更があれば自動で検索するようにしている。
   */

  useEffect(function () {
    if (didMountRef.current) {
      searchWithCondition();
    } // TODO: Implementation before introducing rules

  }, [state.query, state.selectedPlacement, state.selectedDuration, state.selectedAspect, state.selectedIndustry, state.includeOtherOrganizations, state.selectedOrganizations, state.selectedOrganizationTags, state.selectdContentTypes, state.scope, state.service, state.offset, state.limit, state.isOriginal]);
  /**
   * コンポーネントマウント時に実行されるHooks.
   * パラメーターにidsがある時に、モーダルを展開
   */

  useEffect(function () {
    // クエパラがあればモーダル開く
    var ids = idsStr ? idsStr.split(",") : undefined;

    if (ids) {
      if (ids.length !== 0 && isPC) {
        dispatch(adSearchPageActions.setModalTypeAction("preview"));

        var f = function f() {
          return __awaiter(void 0, void 0, void 0, function () {
            var cards;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  return [4
                  /*yield*/
                  , setSelectedCardDataByIds(ids)];

                case 1:
                  cards = _a.sent();

                  if (cards && cards.length !== 0) {
                    if (cards.length === 1 && state.selectedCard) {
                      dispatch(adSearchPageActions.selectCardAction(cards[0]));
                    } else {
                      dispatch(adSearchPageActions.selectCardsAction(cards));
                    }
                  }

                  return [2
                  /*return*/
                  ];
              }
            });
          });
        };

        f();
      }

      if (ids.length !== 0 && !isPC) {
        dispatch(adSearchPageActions.setSpCardModal(true));

        var f = function f() {
          return __awaiter(void 0, void 0, void 0, function () {
            var cards;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  return [4
                  /*yield*/
                  , setSelectedCardDataByIds([ids[0]])];

                case 1:
                  cards = _a.sent();
                  if (cards && cards.length > 0) showDetail(cards[0]);
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        };

        f();
      }
    }
  }, [idsStr]);
  /**
   * コンポーネントマウント時に実行されるHooks.
   * データの初期化
   */

  useEffect(function () {
    if (staticQuery === null || staticQuery === void 0 ? void 0 : staticQuery.service) {
      dispatch(adSearchPageActions.setIsOriginal(staticQuery.service.includes("sales") ? undefined : staticQuery.service.includes("ad") ? true : undefined));
    }

    if (targetStreamingUrl) {
      dispatch(adSearchPageActions.setTargetStreamingUrlAction(targetStreamingUrl));
    }

    if (loadingImageSrc) {
      dispatch(adSearchPageActions.setLoadingImageSrcAction(loadingImageSrc));
    }

    if (staticQuery) {
      var request = __assign(__assign({}, searchQueryCacheState), staticQuery);

      dispatch(adSearchPageActions.rehydrate(request));
      getAdVideo(request, true);
      dispatch(adSearchPageActions.setCursorAction(0));
    } else {
      var request = __assign({}, searchQueryCacheState);

      getAdVideo(request, true);
    }

    organizationId && dispatch(adSearchPageActions.setCurrentOrganizationId(organizationId));
    dispatch(adSearchPageActions.setInialLoadFlgAction());
    didMountRef.current = true; // TODO: Implementation before introducing rules
  }, []);
  /**
   * 選択された条件で検索クエリを実行する。検索の際はoffsetを0に戻す。
   */

  var searchWithCondition = function searchWithCondition() {
    var request = _generateRequest(0);

    getAdVideo(request);
    dispatch(adSearchPageActions.setCursorAction(0));
  };
  /**
   * viewpointギリギリまでスクロールした時に発火する関数。次のページングを読み込む。
   */


  var fetchNextCreatives = function fetchNextCreatives() {
    var newCursor = state.cursor + 1;

    var request = _generateRequest(newCursor);

    if (didMountRef.current) {
      getMoreAdVideo(request);
    } else {
      didMountRef.current = true;
    }

    dispatch(adSearchPageActions.setCursorAction(newCursor));
  };
  /**
   * クリックされたtagを追加する. APIの返りを待たずにUIにも変更を加える.
   * inputが空文字なら追加しない。
   *
   * @param cid creative id
   * @param text 対象となるtagのname
   */


  var onClickTagAdd = function onClickTagAdd(creative, text, organizationId) {
    if (text === "") {
      return;
    }

    addTagToCreative(creative, text, organizationId); // 追加されたタグを現在選択中のカードにも反映させる

    var newCreative = __assign(__assign({}, creative), {
      organizationTag: __spreadArray([text], creative.organizationTag)
    });

    dispatch(adSearchPageActions.selectCardAction(newCreative));
    dispatch(adSearchPageActions.inputNewTagAction(""));
  };
  /**
   * クリックされたtagを削除する
   * @param creative
   * @param name
   */


  var onClickTagDelete = function onClickTagDelete(creative, name, organizationId) {
    deleteTagToCreative(creative, name, organizationId);

    var newCreative = __assign(__assign({}, creative), {
      organizationTag: __spreadArray([], creative.organizationTag.filter(function (tag) {
        return tag !== name;
      }))
    });

    dispatch(adSearchPageActions.selectCardAction(newCreative));
  };
  /**
   * cardのstarがclickされたとき
   * @param cid creative id
   * @param name 対象となるtagのname
   */


  var updateFavStatus = function updateFavStatus(creative) {
    var shouldFavorite = creative.favorite ? 0 : 1;
    setFavUnfav(creative.id, shouldFavorite);
  };

  var _generateRequest = function _generateRequest(cursor) {
    return __assign({
      query: state.query,
      industry: state.selectedIndustry === "" ? undefined : state.selectedIndustry,
      duration: state.selectedDuration === "" ? undefined : state.selectedDuration,
      aspectRatio: state.selectedAspect === "" ? undefined : state.selectedAspect,
      placement: state.selectedPlacement === "" ? undefined : state.selectedPlacement,
      offset: typeof state.offset === "number" && state.offset >= 0 && state.offset || cursor * OFFSET_WIDTH,
      limit: state.limit,
      selectedOrganizations: state.selectedOrganizations,
      organizationTag: state.selectedOrganizationTags,
      includeOtherOrganizations: state.includeOtherOrganizations,
      contentTypes: state.selectdContentTypes,
      businessRegion: state.businessRegion,
      scope: state.scope,
      service: state.service,
      isOriginal: state.isOriginal,
      isPublishedAtSales: state.isPublishedAtSales
    }, staticQuery);
  };

  var isLoadingMoreVideos = state.initialLoaded && isLoading; // export 先で useEffect などで使用された場合に無限ループすることを防ぐためのメモ化を目的に、useCallback を使用しています

  var setAdditionalQuery = useCallback(function (query) {
    dispatch(adSearchPageActions.setAdditionalCondition(query)); // dispatch, adSearchPageActions, setAdditionalCondition は毎描画更新されるため deps から除外しています
  }, []);

  var handleChangeQuery = function handleChangeQuery(e) {
    var selectedValue = e.target.value;
    if (typeof selectedValue !== "string") throw new Error("invalid select item");
    dispatch(adSearchPageActions.inputQueryAction(selectedValue));
  };

  var setSpSearchModal = function setSpSearchModal(status) {
    dispatch(adSearchPageActions.setSpSearchModal(status));
  };

  var clearCheckedCards = function clearCheckedCards() {
    dispatch(adSearchPageActions.selectCardsAction([]));
  };

  var setLocale = function setLocale(locale) {
    LocaleDispatch({
      type: "SET_LOCALE",
      payload: locale
    });
  };

  var isMobile = state.isMobile,
      query = state.query,
      isOpenSearchMobileModal = state.isOpenSearchMobileModal,
      checkedCards = state.checkedCards,
      selectedCard = state.selectedCard;
  return {
    isLoadingMoreVideos: isLoadingMoreVideos,
    data: data,
    searchWithCondition: searchWithCondition,
    onClickTagDelete: onClickTagDelete,
    updateFavStatus: updateFavStatus,
    fetchNextCreatives: fetchNextCreatives,
    onClickTagAdd: onClickTagAdd,
    selectdCards: checkedCards,
    closeMobileModal: closeMobileModal,
    selectedCardForModal: selectedCardForModal,
    setAdditionalQuery: setAdditionalQuery,
    isMobile: isMobile,
    searchKeyWord: query,
    handleChangeQuery: handleChangeQuery,
    setSpSearchModal: setSpSearchModal,
    clearCheckedCards: clearCheckedCards,
    isOpenSearchMobileModal: isOpenSearchMobileModal,
    apiErrors: apiErrors,
    resetApiErrors: resetApiErrors,
    setLocale: setLocale,
    selectedCardForMobileModal: selectedCard,
    fetchCreativesByIds: setSelectedCardDataByIds
  };
};

/**
 * __useCreativeSearchContext__
 * 検索用のコンテキスト、メソッドをラップしたHooks
 * hooks `useCreativeSearchContext` を使用するコンポーネントは、コンポーネント `CreativeSearchProvider` で親コンポーネントをラップする必要があります。
 * ラップせずに hooks `useCreativeSearch` を呼び出した場合、エラーが発生します。
 * 内部で `useContext` を利用しているため、コンポーネント `CreativeSearchProvider` でラップした子コンポーネント、孫コンポーネントでもコンテキストを利用できます。
 * @example
 *  const {
 *    state: {
 *      searchFormInputs: { offset, limit },
 *    },
 *    methods: {
 *      searchFormInputs: { changeOffset, changeLimit },
 *    },
 *  } = useCreativeSearchContext();
 */

var useCreativeSearchContext = function useCreativeSearchContext() {
  var _a = useFilterContext(),
      filterState = _a.state,
      filterMethods = _a.methods;

  var _b = useAdSearchPageStateContext(),
      offset = _b.offset,
      limit = _b.limit;

  var dispatch = useAdSearchPageDispatchContext().dispatch;
  var setOffset = adSearchPageActions.setOffset,
      setLimit = adSearchPageActions.setLimit;
  var changeOffset = useCallback(function (offset) {
    dispatch(setOffset(offset));
  }, []);
  var changeLimit = useCallback(function (limit) {
    dispatch(setLimit(limit));
  }, []);
  return {
    state: {
      searchFormInputs: {
        filter: filterState,
        offset: offset,
        limit: limit
      }
    },
    methods: {
      searchFormInputs: {
        filter: filterMethods,
        changeOffset: changeOffset,
        changeLimit: changeLimit
      }
    }
  };
};

export { Container, Creative, CreativeIndexForDirectorWeb, CreativeList, CreativeSearchProvider, Filter, ImageViewer, KeywordForm, MobileModal, Modal, SelectController, VideoViewer, useCreativeSearch, useCreativeSearchContext };
